var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
const SvgComponent = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 72,
  height: 72,
  viewBox: "0 0 72 72"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  id: "Path_646",
  "data-name": "Path 646",
  d: "M36,0A36,36,0,1,1,0,36,36,36,0,0,1,36,0Z",
  fill: "#ededff"
})), _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "man_came_up_with_a_good_plan",
  "data-name": "man came up with a good plan",
  transform: "translate(-219.213 -230.981)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_649",
  "data-name": "Path 649",
  d: "M2026.461,245.7c2.613,0,4.731-.814,4.731-1.819s-2.118-1.819-4.731-1.819-4.731.814-4.731,1.819S2023.848,245.7,2026.461,245.7Z",
  transform: "translate(-1757.556 -3.976)",
  fill: "#fdbc12"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_650",
  "data-name": "Path 650",
  d: "M2022.485,241.806a9.737,9.737,0,0,1-3.376-.539c-.928-.357-1.44-.841-1.44-1.364s.511-1.009,1.44-1.364a10.849,10.849,0,0,1,6.751,0c.929.357,1.44.843,1.44,1.366s-.511,1.009-1.44,1.364A9.782,9.782,0,0,1,2022.485,241.806Zm0-3.638a9.559,9.559,0,0,0-3.316.527c-.846.325-1.332.765-1.332,1.207s.486.882,1.332,1.207a10.687,10.687,0,0,0,6.631,0c.847-.325,1.332-.765,1.332-1.206s-.486-.882-1.332-1.207A9.522,9.522,0,0,0,2022.485,238.168Z",
  transform: "translate(-1753.58 0)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_651",
  "data-name": "Path 651",
  d: "M803.8,1076.987l-.557,2,5.849-1.1-.8-1.81Z",
  transform: "translate(-564.302 -820.721)",
  fill: "#f6aa65"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_652",
  "data-name": "Path 652",
  d: "M800.581,1076.383a.059.059,0,0,1-.025-.006.059.059,0,0,1-.02-.016.056.056,0,0,1-.01-.023.055.055,0,0,1,0-.026l.558-2a.057.057,0,0,1,.043-.04l4.493-.907a.055.055,0,0,1,.037.005.057.057,0,0,1,.026.027l.8,1.811a.059.059,0,0,1,.006.024.053.053,0,0,1-.021.043.056.056,0,0,1-.022.011l-5.853,1.1Zm.6-2.012-.523,1.884,5.69-1.07-.751-1.7Z",
  transform: "translate(-561.645 -818.057)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_653",
  "data-name": "Path 653",
  d: "M894.688,1171.212s.149,1.936.615,1.65l.623-.05-.857,1.469-2.412.94-.131-2.027s.658.159.852-.406a3.827,3.827,0,0,0-.216-1.768Z",
  transform: "translate(-651.74 -913.694)",
  fill: "#f6aa65"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_654",
  "data-name": "Path 654",
  d: "M889.982,1172.581a.055.055,0,0,1-.03-.009.054.054,0,0,1-.018-.019.056.056,0,0,1-.008-.025l-.131-2.027a.054.054,0,0,1,.02-.046.055.055,0,0,1,.023-.012.051.051,0,0,1,.026,0c.025.006.611.14.785-.369a3.8,3.8,0,0,0-.215-1.732.056.056,0,0,1,.009-.054.053.053,0,0,1,.023-.017.055.055,0,0,1,.028,0l1.527.192a.056.056,0,0,1,.034.017.055.055,0,0,1,.015.034c.031.405.169,1.485.426,1.616a.094.094,0,0,0,.053.01.1.1,0,0,0,.05-.02.053.053,0,0,1,.025-.008l.624-.05a.056.056,0,0,1,.052.026.058.058,0,0,1,.008.029.057.057,0,0,1-.008.029l-.857,1.469a.054.054,0,0,1-.028.024l-2.412.941A.073.073,0,0,1,889.982,1172.581Zm-.071-2.018.122,1.882,2.322-.905.794-1.359-.5.042a.205.205,0,0,1-.2.007c-.336-.171-.459-1.377-.484-1.662l-1.393-.176a3.517,3.517,0,0,1,.187,1.719.734.734,0,0,1-.843.453Z",
  transform: "translate(-649.067 -910.999)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_655",
  "data-name": "Path 655",
  d: "M605.873,1461.074s-2.3,2.593,2.106,8.572l8.424-.395-7.836-9.411Z",
  transform: "translate(-370.436 -1196.532)",
  fill: "#dc5c3f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_656",
  "data-name": "Path 656",
  d: "M605.323,1467.083a.055.055,0,0,1-.025-.006.053.053,0,0,1-.02-.017,16.265,16.265,0,0,1-2.2-3.876,7.388,7.388,0,0,1-.521-2.686,3.31,3.31,0,0,1,.615-2.08.053.053,0,0,1,.019-.014l2.694-1.233a.053.053,0,0,1,.036,0,.055.055,0,0,1,.031.019l7.836,9.41a.056.056,0,0,1-.04.092l-8.424.395Zm-2.071-8.582a3.326,3.326,0,0,0-.579,2.01c-.019,1.26.43,3.4,2.678,6.458l8.282-.388-7.735-9.291Z",
  transform: "translate(-367.781 -1193.913)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_657",
  "data-name": "Path 657",
  d: "M243.613,873.7c-.448-.241-1.046-2.345-1.943-4.332s-1.046-1.734-4.036-3.729-8.57-5.557-5.879-8.908,10.409-2.376,13.1-2a20.128,20.128,0,0,1,.1,4.781l2.075-.444-.58-4.425s8.022-6.454,11.182-2.819c3.13,3.6-2.445,9.292-2.445,9.292s5.514,10.763,2.973,11.8Z",
  transform: "translate(-3.959 -600.022)",
  fill: "#fdbc12"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_658",
  "data-name": "Path 658",
  d: "M992.306,1036.956a.228.228,0,1,0-.228-.228A.228.228,0,0,0,992.306,1036.956Z",
  transform: "translate(-749.231 -781.961)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_659",
  "data-name": "Path 659",
  d: "M989.656,1034.364a.284.284,0,1,1,.109-.547.284.284,0,0,1,.175.262.285.285,0,0,1-.284.284Zm0-.456a.172.172,0,1,0,.122.05.172.172,0,0,0-.122-.05Z",
  transform: "translate(-746.581 -779.312)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_660",
  "data-name": "Path 660",
  d: "M679.658,1023.664h-.006c-.352-.037-.718-.083-1.072-.127a21.918,21.918,0,0,0-2.974-.236h0a.326.326,0,0,1-.326-.3l-.047-.675a.057.057,0,0,1,0-.022.056.056,0,0,1,.011-.019.056.056,0,0,1,.1.033l.049.675a.213.213,0,0,0,.217.2,21.891,21.891,0,0,1,2.99.237c.354.044.719.09,1.07.127a.055.055,0,0,1,.039.018.056.056,0,0,1,0,.079.055.055,0,0,1-.04.015Z",
  transform: "translate(-438.943 -768.019)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_661",
  "data-name": "Path 661",
  d: "M978.936,932.783a.056.056,0,0,1-.054-.04.056.056,0,0,1,0-.035.054.054,0,0,1,.021-.028c.336-.226.666-.463.985-.691a20.269,20.269,0,0,1,2.424-1.56c.284-.149.211-.348.147-.523l-.005-.015a1.582,1.582,0,0,0-.259-.457.056.056,0,0,1-.012-.041.055.055,0,0,1,.02-.038.056.056,0,0,1,.041-.012.056.056,0,0,1,.038.021,1.7,1.7,0,0,1,.277.49l.005.015a.459.459,0,0,1-.2.663,20.2,20.2,0,0,0-2.411,1.551c-.319.229-.65.465-.987.693A.055.055,0,0,1,978.936,932.783Z",
  transform: "translate(-736.306 -677.023)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_662",
  "data-name": "Path 662",
  d: "M239.655,869.822a.085.085,0,0,1-.04-.01,5.763,5.763,0,0,1-1.089-2.188c-.262-.673-.555-1.438-.892-2.184-.71-1.57-.917-1.7-2.536-2.738-.391-.25-.878-.56-1.47-.956l-.266-.178c-2.364-1.573-5.937-3.954-6.328-6.482a2.964,2.964,0,0,1,.7-2.372c1.167-1.453,3.391-2.27,6.611-2.429a35.813,35.813,0,0,1,6.565.4.084.084,0,0,1-.023.167c-6.824-.959-11.205-.3-13.022,1.966a2.8,2.8,0,0,0-.661,2.242c.38,2.455,3.916,4.809,6.255,6.367l.267.178c.593.394,1.078.706,1.467.954,1.62,1.035,1.868,1.193,2.6,2.811.339.75.635,1.516.9,2.192a7.025,7.025,0,0,0,.993,2.089l14.509-.779a.88.88,0,0,0,.481-.546c.91-2.459-3.465-11.046-3.509-11.132a.085.085,0,0,1-.008-.051.083.083,0,0,1,.023-.046,16.337,16.337,0,0,0,2.384-3.28c1.311-2.45,1.33-4.435.058-5.9a3.408,3.408,0,0,0-3.009-1.064,10.633,10.633,0,0,0-3.665,1.13,26.178,26.178,0,0,0-4.355,2.734l.66,4.755a.085.085,0,0,1,0,.036.083.083,0,0,1-.017.031.086.086,0,0,1-.064.029l-2.1,0a.084.084,0,0,1,0-.168l2.007,0-.655-4.708a.083.083,0,0,1,.031-.077,26.355,26.355,0,0,1,4.422-2.783,10.79,10.79,0,0,1,3.726-1.147,3.567,3.567,0,0,1,3.15,1.121,3.967,3.967,0,0,1,.959,3.032,7.979,7.979,0,0,1-1,3.059,16.518,16.518,0,0,1-2.369,3.271c.177.35,1.184,2.362,2.083,4.608,1.329,3.318,1.8,5.542,1.408,6.607a1.052,1.052,0,0,1-.587.648.084.084,0,0,1-.027.006l-14.55.782Z",
  transform: "translate(0 -596.063)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_663",
  "data-name": "Path 663",
  d: "M1026.153,1282.745a.056.056,0,0,1-.055-.045,30.692,30.692,0,0,0-3.809-9.468,26.758,26.758,0,0,0-2.589-3.622.055.055,0,0,1-.015-.04.054.054,0,0,1,.005-.021.056.056,0,0,1,.013-.017.057.057,0,0,1,.079,0,26.689,26.689,0,0,1,2.6,3.639,30.814,30.814,0,0,1,3.823,9.5.053.053,0,0,1,0,.022.054.054,0,0,1-.008.02.056.056,0,0,1-.015.016.055.055,0,0,1-.02.008Z",
  transform: "translate(-776.267 -1010.152)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_664",
  "data-name": "Path 664",
  d: "M2312.161,2641.38l2.492,1.243.908-.1-1.087,1.257-4.394-1.714Z",
  transform: "translate(-2039.933 -2353.598)",
  fill: "#f6aa65"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_665",
  "data-name": "Path 665",
  d: "M2310.448,2639.9a.092.092,0,0,1-.031-.005l-4.4-1.714a.084.084,0,0,1-.039-.032.082.082,0,0,1-.014-.049.087.087,0,0,1,.016-.048.085.085,0,0,1,.041-.029l2.081-.687a.084.084,0,0,1,.064,0l2.47,1.233.883-.1a.088.088,0,0,1,.049.009.087.087,0,0,1,.044.084.085.085,0,0,1-.02.045l-1.087,1.256a.079.079,0,0,1-.028.021A.093.093,0,0,1,2310.448,2639.9Zm-4.146-1.792,4.121,1.607.908-1.05-.7.075a.081.081,0,0,1-.046-.009l-2.461-1.228Z",
  transform: "translate(-2035.907 -2349.635)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_666",
  "data-name": "Path 666",
  d: "M2329.754,2551.7l3.195,3.14.908-.1-1.125,1.218-6.532-3.281Z",
  transform: "translate(-2055.719 -2265.776)",
  fill: "#f6aa65"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_667",
  "data-name": "Path 667",
  d: "M2328.767,2552.07a.084.084,0,0,1-.037-.009l-6.533-3.281a.086.086,0,0,1-.046-.084.083.083,0,0,1,.02-.046.078.078,0,0,1,.042-.027l3.554-.98a.086.086,0,0,1,.044,0,.089.089,0,0,1,.038.021l3.167,3.113.868-.093a.082.082,0,0,1,.05.01.08.08,0,0,1,.035.036.085.085,0,0,1,.008.049.082.082,0,0,1-.021.045l-1.125,1.218a.092.092,0,0,1-.028.02.083.083,0,0,1-.034.008Zm-6.3-3.343,6.28,3.155.93-1.009-.686.075a.082.082,0,0,1-.036,0,.081.081,0,0,1-.031-.019l-3.16-3.105Z",
  transform: "translate(-2051.753 -2261.8)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_668",
  "data-name": "Path 668",
  d: "M2313.5,2530.66l-3.417,2.981,2.275.875a6.913,6.913,0,0,1,2.195-2.848Z",
  transform: "translate(-2039.933 -2245.172)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_669",
  "data-name": "Path 669",
  d: "M1743.06,2396.763a138.59,138.59,0,0,0,12.942,6.386,8.143,8.143,0,0,1,1.329-2.525l-14.271-4.484Z",
  transform: "translate(-1484.658 -2113.438)",
  fill: "#34728c"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_670",
  "data-name": "Path 670",
  d: "M484.949,1891.4h26.059v11.078a.474.474,0,0,1-.474.474H485.422a.474.474,0,0,1-.474-.474Z",
  transform: "translate(-252.606 -1619.153)",
  fill: "#9cbd6b"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_671",
  "data-name": "Path 671",
  d: "M507.885,1900.353H482.772a.53.53,0,0,1-.53-.53v-11.078a.057.057,0,0,1,.016-.04.056.056,0,0,1,.04-.016h26.059a.056.056,0,0,1,.056.056v11.078a.53.53,0,0,1-.529.53Zm-25.53-11.55v11.022a.418.418,0,0,0,.417.417h25.112a.418.418,0,0,0,.417-.417V1888.8Z",
  transform: "translate(-249.956 -1616.499)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_672",
  "data-name": "Path 672",
  d: "M1743.06,1921.806s1.814-.365,3.674,1.661,11.958,11.36,11.958,11.36-.465.133-1.362,1.262l-14.271-4.484Z",
  transform: "translate(-1484.658 -1648.904)",
  fill: "#34728c"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_673",
  "data-name": "Path 673",
  d: "M924.428,1165.534s.03.292.105.762a2.974,2.974,0,0,1-1.368-.321l-.2-.856Z",
  transform: "translate(-681.547 -907.916)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_674",
  "data-name": "Path 674",
  d: "M2116.286,2250.734a1.652,1.652,0,0,1-.42-3.249.056.056,0,0,1,.043.006.054.054,0,0,1,.026.035.055.055,0,0,1-.005.042.057.057,0,0,1-.034.026,1.539,1.539,0,1,0,1.9,1.8.054.054,0,0,1,.024-.035.055.055,0,0,1,.078.016.054.054,0,0,1,.008.042,1.655,1.655,0,0,1-1.617,1.319Z",
  transform: "translate(-1848.535 -1967.86)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_675",
  "data-name": "Path 675",
  d: "M1953.551,2514.209h-.014a.056.056,0,0,1-.02-.01.052.052,0,0,1-.015-.016.049.049,0,0,1-.008-.021.066.066,0,0,1,0-.022,1.339,1.339,0,0,0-2.326-1.186.064.064,0,0,1-.017.014.054.054,0,0,1-.021.006.05.05,0,0,1-.022,0,.057.057,0,0,1-.019-.01.054.054,0,0,1-.014-.017.053.053,0,0,1-.006-.021.056.056,0,0,1,.013-.041,1.451,1.451,0,0,1,2.521,1.286.056.056,0,0,1-.02.031A.058.058,0,0,1,1953.551,2514.209Z",
  transform: "translate(-1688.36 -2227.252)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_676",
  "data-name": "Path 676",
  d: "M1759.407,2263.332a1.287,1.287,0,1,1,.908-.377,1.285,1.285,0,0,1-.908.377Zm0-2.458a1.176,1.176,0,1,0,.829.345,1.174,1.174,0,0,0-.829-.345Z",
  transform: "translate(-1499.407 -1980.864)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_677",
  "data-name": "Path 677",
  d: "M1799,2002.338a1,1,0,1,1,.7-.292A1,1,0,0,1,1799,2002.338Zm0-1.877a.884.884,0,1,0,.624.259A.882.882,0,0,0,1799,2000.461Z",
  transform: "translate(-1538.469 -1725.845)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_678",
  "data-name": "Path 678",
  d: "M2212.995,2636.942a.054.054,0,0,1-.026-.007.058.058,0,0,1-.027-.033.059.059,0,0,1,0-.042.883.883,0,0,0-.417-1.221.884.884,0,0,0-1,.2.878.878,0,0,0-.19.3.055.055,0,0,1-.03.027.058.058,0,0,1-.04,0,.057.057,0,0,1-.031-.026.054.054,0,0,1,0-.04.99.99,0,0,1,.547-.577,1,1,0,0,1,.8.008.994.994,0,0,1,.468,1.381.056.056,0,0,1-.049.028Z",
  transform: "translate(-1943.133 -2347.788)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_679",
  "data-name": "Path 679",
  d: "M1740.406,2121.16a.056.056,0,0,1-.056-.056.056.056,0,0,1,.056-.056.258.258,0,0,0,0-.516.056.056,0,0,1-.04-.016.055.055,0,0,1-.016-.04.056.056,0,0,1,.056-.056.37.37,0,0,1,0,.74Z",
  transform: "translate(-1482.004 -1843.429)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_680",
  "data-name": "Path 680",
  d: "M2006.868,2153.088a.369.369,0,0,1-.206-.063.371.371,0,0,1-.158-.38.37.37,0,0,1,.5-.27.371.371,0,0,1,.229.342.371.371,0,0,1-.37.37Zm0-.629a.258.258,0,1,0,.183.076.258.258,0,0,0-.183-.076Z",
  transform: "translate(-1742.639 -1874.696)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_681",
  "data-name": "Path 681",
  d: "M2356.806,2488.1a.371.371,0,1,1,.262-.109.372.372,0,0,1-.262.109Zm0-.629a.259.259,0,0,0-.254.309.261.261,0,0,0,.071.133.258.258,0,0,0,.281.056.262.262,0,0,0,.116-.095.259.259,0,0,0-.215-.4Z",
  transform: "translate(-2085.328 -2202.771)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_682",
  "data-name": "Path 682",
  d: "M2151.919,2524.865a.544.544,0,0,1-.481-.293.541.541,0,0,1,.039-.562.059.059,0,0,1,.036-.022.058.058,0,0,1,.042.01.054.054,0,0,1,.022.036.055.055,0,0,1-.008.042.43.43,0,0,0,.035.54.429.429,0,0,0,.535.078.436.436,0,0,0,.14-.134.426.426,0,0,0,.066-.181.057.057,0,0,1,.021-.038.056.056,0,0,1,.042-.011.057.057,0,0,1,.049.063.541.541,0,0,1-.539.474Z",
  transform: "translate(-1884.518 -2238.637)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_683",
  "data-name": "Path 683",
  d: "M1983.606,2339.658a.542.542,0,1,1,.383-.158.544.544,0,0,1-.383.158Zm0-.971a.43.43,0,1,0,.3.126.43.43,0,0,0-.3-.126Z",
  transform: "translate(-1719.691 -2057.065)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_684",
  "data-name": "Path 684",
  d: "M883.05,1060.32l-.321-.36,1.631-1.42a6.273,6.273,0,0,1,.695,1.164.92.92,0,0,0,.527.285c.088,0-.187.363-.284.411.008.04.324.651.212.776-.362.406-1.682.368-1.943-.306a.522.522,0,0,1-.681-.025A.3.3,0,0,1,883.05,1060.32Z",
  transform: "translate(-642.147 -803.544)",
  fill: "#f6aa65"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_685",
  "data-name": "Path 685",
  d: "M882.046,1058.895a1.908,1.908,0,0,1-.345-.031,1.087,1.087,0,0,1-.813-.511.566.566,0,0,1-.7-.071.36.36,0,0,1-.1-.364.395.395,0,0,1,.209-.224l-.265-.3a.057.057,0,0,1-.014-.041.058.058,0,0,1,.019-.037l1.631-1.42a.057.057,0,0,1,.02-.012.06.06,0,0,1,.023,0,.056.056,0,0,1,.039.022,6.281,6.281,0,0,1,.7,1.167.845.845,0,0,0,.479.262.071.071,0,0,1,.071.056c.021.093-.174.339-.286.432l.017.037c.17.377.262.649.168.755A1.194,1.194,0,0,1,882.046,1058.895Zm-1.133-.681.016,0a.055.055,0,0,1,.023.012.058.058,0,0,1,.015.021.939.939,0,0,0,.757.5,1.3,1.3,0,0,0,1.092-.214c.025-.028.033-.147-.187-.635a.654.654,0,0,1-.038-.093.058.058,0,0,1,0-.036.056.056,0,0,1,.026-.026,1.069,1.069,0,0,0,.256-.308,1.039,1.039,0,0,1-.516-.3.059.059,0,0,1-.012-.019,5.9,5.9,0,0,0-.651-1.1l-1.542,1.345.283.317a.055.055,0,0,1,.013.026.054.054,0,0,1,0,.029.055.055,0,0,1-.016.024.051.051,0,0,1-.026.013.3.3,0,0,0-.129.063.3.3,0,0,0-.084.116.259.259,0,0,0,.08.255.467.467,0,0,0,.605.016.059.059,0,0,1,.031-.013Z",
  transform: "translate(-639.493 -800.944)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_686",
  "data-name": "Path 686",
  d: "M959.875,1098.4a.056.056,0,0,1-.032-.01.056.056,0,0,1-.022-.061.056.056,0,0,1,.019-.028.787.787,0,0,0,.256-.37.055.055,0,0,1,.026-.034.056.056,0,0,1,.062,0,.052.052,0,0,1,.014.016.055.055,0,0,1,.007.021.053.053,0,0,1,0,.021.882.882,0,0,1-.294.43.058.058,0,0,1-.035.012Z",
  transform: "translate(-717.64 -842.074)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_687",
  "data-name": "Path 687",
  d: "M895.419,1155.428a.055.055,0,0,1-.037-.014l-.2-.18a.056.056,0,0,1,.034-.1.057.057,0,0,1,.041.014l.2.182a.056.056,0,0,1,.015.062.056.056,0,0,1-.021.026.056.056,0,0,1-.032.01Z",
  transform: "translate(-654.319 -898.139)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_688",
  "data-name": "Path 688",
  d: "M899.381,1152.889a.057.057,0,0,1-.032-.01.056.056,0,0,1-.02-.027.056.056,0,0,1,.018-.062l.156-.124a.053.053,0,0,1,.02-.011.056.056,0,0,1,.022,0,.058.058,0,0,1,.022.006.061.061,0,0,1,.017.015.054.054,0,0,1,.01.02.056.056,0,0,1,0,.023.055.055,0,0,1-.008.021.059.059,0,0,1-.015.017l-.157.124a.054.054,0,0,1-.035.012Z",
  transform: "translate(-658.399 -895.705)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_689",
  "data-name": "Path 689",
  d: "M1335.351,2198.537c.028-.034.055-.048.094,0s0,.058-.023.082-.056.05-.1,0S1335.326,2198.562,1335.351,2198.537Z",
  transform: "translate(-1085.353 -1919.898)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_690",
  "data-name": "Path 690",
  d: "M1642.629,2363.212c-.015-.016-.038-.033-.027-.057s.047-.022.075-.022a.069.069,0,0,1,.039.014.066.066,0,0,1,.024.034.218.218,0,0,1,0,.081.386.386,0,0,1-.081-.013C1642.65,2363.244,1642.641,2363.225,1642.629,2363.212Z",
  transform: "translate(-1386.278 -2081.114)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_691",
  "data-name": "Path 691",
  d: "M1611.5,2304.6c-.032.02-.044,0-.059-.018a.074.074,0,0,1-.018-.021.076.076,0,0,1-.008-.027.065.065,0,0,1,0-.027.067.067,0,0,1,.013-.024.063.063,0,0,1,.04,0,.066.066,0,0,1,.035.019.1.1,0,0,1,.012.052.1.1,0,0,1-.018.051Z",
  transform: "translate(-1355.736 -2023.676)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_692",
  "data-name": "Path 692",
  d: "M619.26,2097c-.016-.015-.035-.031-.017-.056a.089.089,0,0,1,.107,0c.025.023.007.038-.009.056S619.289,2097.051,619.26,2097Z",
  transform: "translate(-384.112 -1820.426)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_693",
  "data-name": "Path 693",
  d: "M1606.511,2232.992c.018-.018.034-.011.039,0,.01.031.078-.015.062.05-.007.027,0,.057-.038.063s-.034-.025-.051-.038S1606.522,2233.015,1606.511,2232.992Z",
  transform: "translate(-1350.936 -1953.659)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_694",
  "data-name": "Path 694",
  d: "M1159.854,2180.424c-.016-.015-.035-.031-.016-.056a.09.09,0,0,1,.054-.018.091.091,0,0,1,.054.018c.025.022.007.037-.009.055S1159.883,2180.471,1159.854,2180.424Z",
  transform: "translate(-913.509 -1902.118)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_695",
  "data-name": "Path 695",
  d: "M1691.867,2219.477c-.025.024-.042.009-.056-.01s-.05-.037-.016-.068a.052.052,0,0,1,.04-.02.054.054,0,0,1,.053.037.052.052,0,0,1-.005.044A.048.048,0,0,1,1691.867,2219.477Z",
  transform: "translate(-1434.441 -1940.338)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_696",
  "data-name": "Path 696",
  d: "M999.346,2219.674c-.017-.019-.033-.037-.008-.057a.063.063,0,0,1,.043-.016.064.064,0,0,1,.044.016.068.068,0,0,1-.013.077C999.378,2219.723,999.364,2219.69,999.346,2219.674Z",
  transform: "translate(-756.328 -1940.555)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_697",
  "data-name": "Path 697",
  d: "M1267.841,2124.014c.012-.008.027-.037.047-.014a.076.076,0,0,1,.006.034.074.074,0,0,1-.009.033.115.115,0,0,1-.05.046l-.012,0-.012,0-.01-.007a.033.033,0,0,1-.007-.011c0-.009-.01-.025-.006-.03a.531.531,0,0,1,.054-.051Z",
  transform: "translate(-1019.228 -1846.927)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_698",
  "data-name": "Path 698",
  d: "M1223.17,1993.417a.223.223,0,0,1,.016-.079c.023-.034.047-.012.066.011s.034.031.015.056a.13.13,0,0,1-.1.011Z",
  transform: "translate(-975.536 -1718.963)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_699",
  "data-name": "Path 699",
  d: "M777.317,2277.992c-.023,0-.057.005-.065-.006a.069.069,0,0,1,.007-.086.03.03,0,0,1,.009-.008.025.025,0,0,1,.012,0,.026.026,0,0,1,.012,0,.023.023,0,0,1,.01.007C777.336,2277.923,777.312,2277.959,777.317,2277.992Z",
  transform: "translate(-538.843 -1997.636)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_700",
  "data-name": "Path 700",
  d: "M1242.44,2372.249c.012-.019-.014-.052.018-.055s.063-.026.059.027c0,.016.018.052-.023.047C1242.477,2372.263,1242.447,2372.285,1242.44,2372.249Z",
  transform: "translate(-994.407 -2089.981)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_701",
  "data-name": "Path 701",
  d: "M1178.264,2249.017c.02-.009.036-.012.047.007s.022.067,0,.085-.033-.024-.049-.038S1178.252,2249.032,1178.264,2249.017Z",
  transform: "translate(-931.542 -1969.356)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_702",
  "data-name": "Path 702",
  d: "M859.9,2376.38a.219.219,0,0,1-.028-.045c0-.008.007-.02.013-.028a.031.031,0,0,1,.009-.009.029.029,0,0,1,.012,0,.024.024,0,0,1,.012,0,.027.027,0,0,1,.01.007c.032.027.012.062.013.094Z",
  transform: "translate(-619.759 -2094.003)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_703",
  "data-name": "Path 703",
  d: "M926.1,2206.582a.023.023,0,0,1-.007-.01.02.02,0,0,1,0-.011.022.022,0,0,1,.005-.01.019.019,0,0,1,.01-.006c.02-.01.031-.056.061-.025a.066.066,0,0,1,.006.032.064.064,0,0,1-.01.031C926.15,2206.594,926.119,2206.583,926.1,2206.582Z",
  transform: "translate(-684.608 -1927.735)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_704",
  "data-name": "Path 704",
  d: "M1661.085,2336.135c-.031-.008-.07.012-.093-.024a.085.085,0,0,1-.005-.031c.031.007.069-.011.092.023a.091.091,0,0,1,.005.032Z",
  transform: "translate(-1404.285 -2054.623)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_705",
  "data-name": "Path 705",
  d: "M1403.749,2226.384a.033.033,0,0,1,.007-.045c.025-.021.042-.01.056.009a.043.043,0,0,1,.006.011.031.031,0,0,1,0,.013.03.03,0,0,1-.013.021C1403.781,2226.413,1403.765,2226.4,1403.749,2226.384Z",
  transform: "translate(-1152.369 -1947.142)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_706",
  "data-name": "Path 706",
  d: "M1214.895,2069.171c-.013-.011-.02-.025,0-.037s.02.006.028.012.02.026,0,.038S1214.9,2069.177,1214.895,2069.171Z",
  transform: "translate(-967.42 -1793.205)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_707",
  "data-name": "Path 707",
  d: "M1198.127,2064.84c-.005-.023.014-.031.026-.04s.022,0,.023.007c.007.021-.013.029-.026.037S1198.135,2064.843,1198.127,2064.84Z",
  transform: "translate(-951.011 -1788.96)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_708",
  "data-name": "Path 708",
  d: "M1074.669,2040.582c.011-.013.026-.02.037,0s-.006.02-.013.027-.026.021-.037,0S1074.665,2040.591,1074.669,2040.582Z",
  transform: "translate(-830.099 -1765.232)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_709",
  "data-name": "Path 709",
  d: "M1171.138,2249.848a.26.26,0,0,1-.042-.027c-.006-.007,0-.021-.006-.031a.153.153,0,0,1,.042.021C1171.138,2249.817,1171.136,2249.832,1171.138,2249.848Z",
  transform: "translate(-924.535 -1970.12)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_710",
  "data-name": "Path 710",
  d: "M1720.479,2354.87c-.005-.023.014-.03.026-.04a.023.023,0,0,1,.013,0,.026.026,0,0,1,.011.007c.007.021-.013.029-.026.037S1720.487,2354.872,1720.479,2354.87Z",
  transform: "translate(-1462.544 -2072.983)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_711",
  "data-name": "Path 711",
  d: "M1585.677,2375.175c-.005-.023.014-.03.026-.04s.022,0,.023.008c.007.021-.013.029-.026.037S1585.684,2375.177,1585.677,2375.175Z",
  transform: "translate(-1330.533 -2092.867)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_712",
  "data-name": "Path 712",
  d: "M1345.655,2349.277c0-.024.014-.031.026-.041a.024.024,0,0,1,.013,0,.031.031,0,0,1,.011.007c.007.021-.013.029-.026.038S1345.663,2349.28,1345.655,2349.277Z",
  transform: "translate(-1095.483 -2067.506)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_713",
  "data-name": "Path 713",
  d: "M1386.819,2058.215c-.005-.023.014-.03.026-.041a.026.026,0,0,1,.013,0,.023.023,0,0,1,.011.007c.007.021-.013.029-.026.037S1386.827,2058.218,1386.819,2058.215Z",
  transform: "translate(-1135.795 -1782.473)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_714",
  "data-name": "Path 714",
  d: "M1045.526,2119.035l-.006-.025h.016a.1.1,0,0,1,.008.025Z",
  transform: "translate(-801.566 -1842.049)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_715",
  "data-name": "Path 715",
  d: "M1186.48,2007.257v-.018a.113.113,0,0,1,.024.01s0,.01,0,.016Z",
  transform: "translate(-939.606 -1732.593)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_716",
  "data-name": "Path 716",
  d: "M1087.57,2099.4v-.016a.056.056,0,0,1,.026,0c.015.006.015.017,0,.021A.073.073,0,0,1,1087.57,2099.4Z",
  transform: "translate(-842.745 -1822.822)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_717",
  "data-name": "Path 717",
  d: "M1089.422,2099.45c.009,0,.023,0,.025,0s0,.022-.011.02l-.026-.014Z",
  transform: "translate(-844.547 -1822.893)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_718",
  "data-name": "Path 718",
  d: "M800.986,2007.965c.031.031.043.058-.006.092s-.057-.007-.079-.03-.045-.06,0-.094S800.964,2007.939,800.986,2007.965Z",
  transform: "translate(-561.987 -1733.26)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_719",
  "data-name": "Path 719",
  d: "M1382.019,1947.6c.018-.013.036-.035.058-.022s.018.049.016.075a.071.071,0,0,1-.017.037.068.068,0,0,1-.036.021.212.212,0,0,1-.08,0,.42.42,0,0,1,.02-.079C1381.984,1947.62,1382,1947.612,1382.019,1947.6Z",
  transform: "translate(-1131.037 -1674.166)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_720",
  "data-name": "Path 720",
  d: "M892.8,1927.628c-.017-.033.006-.043.022-.057a.067.067,0,0,1,.023-.015.067.067,0,0,1,.054,0,.067.067,0,0,1,.023.015.065.065,0,0,1-.021.074.09.09,0,0,1-.053.006A.094.094,0,0,1,892.8,1927.628Z",
  transform: "translate(-652.006 -1654.554)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_721",
  "data-name": "Path 721",
  d: "M1374.371,1992.3c.016.02.008.035-.007.037-.032.007.008.078-.055.057-.026-.009-.057-.008-.059-.044s.028-.031.043-.046S1374.347,1992.306,1374.371,1992.3Z",
  transform: "translate(-1123.487 -1717.954)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_722",
  "data-name": "Path 722",
  d: "M840.825,2041.234c-.022-.027,0-.042.015-.055s.04-.046.069-.009a.066.066,0,0,1,.013.039.066.066,0,0,1-.013.039.068.068,0,0,1-.044.009.066.066,0,0,1-.039-.022Z",
  transform: "translate(-601.101 -1765.805)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_723",
  "data-name": "Path 723",
  d: "M674.134,2076.29c0-.031.022-.04.037-.053s.037-.023.056,0a.03.03,0,0,1,.009.014.032.032,0,0,1,0,.017.032.032,0,0,1-.024.021.28.28,0,0,1-.078,0Z",
  transform: "translate(-437.873 -1800.148)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_724",
  "data-name": "Path 724",
  d: "M659.818,1917.17a.023.023,0,0,1-.006-.01.023.023,0,0,1,0-.012.022.022,0,0,1,.006-.01.021.021,0,0,1,.01-.005c.021-.009.037-.052.063-.02a.064.064,0,0,1,0,.032.06.06,0,0,1-.013.03C659.87,1917.186,659.841,1917.173,659.818,1917.17Z",
  transform: "translate(-423.847 -1644.322)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_725",
  "data-name": "Path 725",
  d: "M860.754,1973.922c.011-.03-.006-.069.032-.089a.08.08,0,0,1,.031,0c-.009.031,0,.069-.032.089a.076.076,0,0,1-.031,0Z",
  transform: "translate(-620.627 -1699.876)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_726",
  "data-name": "Path 726",
  d: "M793.966,1935.52l.012,0a.027.027,0,0,1,.012,0,.032.032,0,0,1,.011.005.034.034,0,0,1,.008.009c.019.026.007.042-.014.054l-.011,0h-.012l-.011-.005a.032.032,0,0,1-.008-.01C793.934,1935.548,793.948,1935.534,793.966,1935.52Z",
  transform: "translate(-555.201 -1662.355)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_727",
  "data-name": "Path 727",
  d: "M690.375,2169.87c.021,0,.054,0,.061.012a.063.063,0,0,1,0,.032.066.066,0,0,1-.012.03c-.034.021-.037-.023-.056-.038S690.358,2169.882,690.375,2169.87Z",
  transform: "translate(-453.763 -1891.855)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_728",
  "data-name": "Path 728",
  d: "M720.077,2059.419c.019-.013.037-.026.055,0a.16.16,0,0,1,.01.029h-.075Z",
  transform: "translate(-482.854 -1783.677)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_729",
  "data-name": "Path 729",
  d: "M764.348,2190.624c.013-.011.027-.018.037,0s-.008.019-.015.026-.027.018-.037,0S764.342,2190.633,764.348,2190.624Z",
  transform: "translate(-526.202 -1912.168)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_730",
  "data-name": "Path 730",
  d: "M894.513,2150.6c.023,0,.029.017.037.03s0,.022-.01.023c-.021.005-.027-.016-.037-.029S894.51,2150.613,894.513,2150.6Z",
  transform: "translate(-653.677 -1872.989)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_731",
  "data-name": "Path 731",
  d: "M644.914,1959.11h.029a.163.163,0,0,1-.025.037c-.006.006-.02,0-.031,0a.04.04,0,0,1,.007-.024.041.041,0,0,1,.02-.016Z",
  transform: "translate(-409.231 -1685.46)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_732",
  "data-name": "Path 732",
  d: "M588.889,1881.676c.023,0,.029.017.037.03s0,.021-.01.023c-.022,0-.028-.016-.037-.029S588.886,1881.684,588.889,1881.676Z",
  transform: "translate(-354.384 -1609.63)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_733",
  "data-name": "Path 733",
  d: "M837.7,2030.734c.023,0,.029.017.037.029a.027.027,0,0,1-.01.023c-.021,0-.028-.016-.037-.029S837.7,2030.742,837.7,2030.734Z",
  transform: "translate(-598.04 -1755.601)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_734",
  "data-name": "Path 734",
  d: "M575.864,2195.274l.026,0c0,.006,0,.015,0,.016l-.025.006Z",
  transform: "translate(-341.636 -1916.729)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_735",
  "data-name": "Path 735",
  d: "M700.023,1944.042l0,.026c-.006,0-.015,0-.016,0a.144.144,0,0,1-.006-.026Z",
  transform: "translate(-463.208 -1670.703)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_736",
  "data-name": "Path 736",
  d: "M605.432,2191.917l0-.017a.1.1,0,0,1,.023.012s0,.011,0,.016Z",
  transform: "translate(-370.594 -1913.429)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_737",
  "data-name": "Path 737",
  d: "M711.687,2077.37l.017,0a.1.1,0,0,1-.012.023s-.01,0-.016,0Z",
  transform: "translate(-474.638 -1801.271)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_738",
  "data-name": "Path 738",
  d: "M1619.126,1914.8c-.016-.015-.035-.031-.017-.056a.089.089,0,0,1,.107,0c.025.022.007.037-.009.056S1619.155,1914.851,1619.126,1914.8Z",
  transform: "translate(-1363.267 -1642)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_739",
  "data-name": "Path 739",
  d: "M1552.219,1951.19c.021,0,.054,0,.061.013a.063.063,0,0,1,0,.032.064.064,0,0,1-.012.03c-.034.02-.037-.023-.056-.037S1552.2,1951.2,1552.219,1951.19Z",
  transform: "translate(-1297.756 -1677.705)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_740",
  "data-name": "Path 740",
  d: "M1437.722,1976.594l.026,0c0,.006,0,.014,0,.016l-.026.006Z",
  transform: "translate(-1185.642 -1702.578)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_741",
  "data-name": "Path 741",
  d: "M1467.2,1973.247l0-.018a.088.088,0,0,1,.023.013s0,.01,0,.016Z",
  transform: "translate(-1214.512 -1699.288)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_742",
  "data-name": "Path 742",
  d: "M885.35,1918.074c-.028.026-.052.036-.08-.008s.007-.049.028-.067.054-.038.082.007S885.373,1918.056,885.35,1918.074Z",
  transform: "translate(-644.625 -1645.178)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_743",
  "data-name": "Path 743",
  d: "M1062.7,2338.755c.011.016.03.032.017.052s-.043.013-.067.011a.06.06,0,0,1-.049-.047.2.2,0,0,1,0-.071.476.476,0,0,1,.068.02C1062.685,2338.726,1062.691,2338.744,1062.7,2338.755Z",
  transform: "translate(-818.292 -2057.188)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_744",
  "data-name": "Path 744",
  d: "M1212,1980.437c-.023.021-.037.027-.063,0s-.015-.064-.011-.1c.033.005.066,0,.087.041S1212.031,1980.427,1212,1980.437Z",
  transform: "translate(-964.524 -1706.251)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_745",
  "data-name": "Path 745",
  d: "M985.289,2422.421l-.008.007a.021.021,0,0,1-.01,0,.021.021,0,0,1-.01,0l-.008-.007a.113.113,0,0,1-.012-.038c.041-.01.016-.066.056-.078.013,0,.027-.018.037-.015s.006.023,0,.034C985.333,2422.36,985.337,2422.4,985.289,2422.421Z",
  transform: "translate(-742.535 -2139.046)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_746",
  "data-name": "Path 746",
  d: "M954.443,2000.391c.03-.013.037.007.049.021a.06.06,0,0,1,.013.02.058.058,0,0,1,0,.023.059.059,0,0,1-.019.042.06.06,0,0,1-.035,0,.057.057,0,0,1-.029-.021.082.082,0,0,1,.017-.087Z",
  transform: "translate(-712.353 -1725.882)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_747",
  "data-name": "Path 747",
  d: "M1724.6,2153.387c.012.015.026.031.008.05a.075.075,0,0,1-.048.01.082.082,0,0,1-.044-.02c-.019-.022,0-.034.014-.047S1724.585,2153.344,1724.6,2153.387Z",
  transform: "translate(-1466.495 -1875.687)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_748",
  "data-name": "Path 748",
  d: "M857.135,1951.723c.024-.018.037,0,.047.014s.037.037.006.06a.056.056,0,0,1-.034.01.055.055,0,0,1-.033-.013.056.056,0,0,1,.013-.072Z",
  transform: "translate(-617.063 -1678.218)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_749",
  "data-name": "Path 749",
  d: "M1659.276,2120.88c.02,0,.05,0,.055.012a.058.058,0,0,1,.006.04.059.059,0,0,1-.021.035.029.029,0,0,1-.008.007l-.01,0-.01,0a.027.027,0,0,1-.008-.007C1659.254,2120.937,1659.278,2120.908,1659.276,2120.88Z",
  transform: "translate(-1402.601 -1843.88)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_750",
  "data-name": "Path 750",
  d: "M1514.281,2268.88c.027,0,.033.021.045.037s.019.032,0,.049a.027.027,0,0,1-.045-.015A.237.237,0,0,1,1514.281,2268.88Z",
  transform: "translate(-1260.613 -1988.814)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_751",
  "data-name": "Path 751",
  d: "M1674.607,2033.327a.2.2,0,0,1,.019.042c0,.007-.008.016-.014.022a.02.02,0,0,1-.008.007l-.011,0-.01,0a.024.024,0,0,1-.008-.007c-.024-.026,0-.055,0-.082Z",
  transform: "translate(-1417.579 -1758.124)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_752",
  "data-name": "Path 752",
  d: "M1599.579,2172.453a.024.024,0,0,1,0,.009.021.021,0,0,1,0,.01.021.021,0,0,1-.006.008.017.017,0,0,1-.009,0c-.018.007-.032.045-.055.016a.059.059,0,0,1,0-.029.058.058,0,0,1,.012-.026C1599.534,2172.438,1599.559,2172.45,1599.579,2172.453Z",
  transform: "translate(-1344.081 -1894.375)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_753",
  "data-name": "Path 753",
  d: "M915.631,1971.07c.026.01.061,0,.077.03a.086.086,0,0,1,0,.027c-.026-.009-.061,0-.075-.03C915.628,1971.09,915.633,1971.079,915.631,1971.07Z",
  transform: "translate(-674.367 -1697.173)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_754",
  "data-name": "Path 754",
  d: "M951.754,1914.2a.028.028,0,0,1,0,.021.028.028,0,0,1-.013.017c-.023.016-.037,0-.047-.014a.023.023,0,0,1,0-.01.024.024,0,0,1,0-.011.029.029,0,0,1,.005-.01l.008-.007C951.73,1914.167,951.742,1914.18,951.754,1914.2Z",
  transform: "translate(-709.682 -1641.457)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_755",
  "data-name": "Path 755",
  d: "M1264.791,2399.2c.016.02.008.036-.008.038-.032.007.008.078-.055.057-.027-.009-.057-.008-.059-.043s.028-.032.043-.047S1264.767,2399.214,1264.791,2399.2Z",
  transform: "translate(-1016.177 -2116.433)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_756",
  "data-name": "Path 756",
  d: "M1525.13,2390.855c.011.016.03.032.017.052s-.043.014-.067.011a.059.059,0,0,1-.049-.048.189.189,0,0,1,0-.07.365.365,0,0,1,.068.02C1525.115,2390.827,1525.122,2390.843,1525.13,2390.855Z",
  transform: "translate(-1271.144 -2108.209)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_757",
  "data-name": "Path 757",
  d: "M1508.285,2415.32c.026.01.061,0,.074.03a.075.075,0,0,1,0,.028c-.026-.008-.06,0-.074-.03A.1.1,0,0,1,1508.285,2415.32Z",
  transform: "translate(-1254.745 -2132.221)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_758",
  "data-name": "Path 758",
  d: "M1544.445,2358.449a.027.027,0,0,1,0,.021.03.03,0,0,1-.012.017c-.023.016-.037,0-.047-.014a.025.025,0,0,1,0-.011.02.02,0,0,1,0-.011.029.029,0,0,1,.005-.01l.009-.006C1544.421,2358.419,1544.433,2358.433,1544.445,2358.449Z",
  transform: "translate(-1290.096 -2076.507)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_759",
  "data-name": "Path 759",
  d: "M868.8,2170.474c.011.016.019.032,0,.048a.02.02,0,0,1-.009.005h-.01l-.01,0a.021.021,0,0,1-.008-.007c-.014-.016-.02-.032,0-.049a.027.027,0,0,1,.02-.006A.03.03,0,0,1,868.8,2170.474Z",
  transform: "translate(-628.452 -1892.438)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_760",
  "data-name": "Path 760",
  d: "M1213.583,2067.711c-.016.014-.033.02-.037,0s.024-.026.037-.039.028-.016.032,0S1213.588,2067.7,1213.583,2067.711Z",
  transform: "translate(-966.111 -1791.766)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_761",
  "data-name": "Path 761",
  d: "M1613.816,1994.372a.6.6,0,0,0-.06-.034c-.026-.01-.008-.022,0-.029s.034-.02.047,0A.406.406,0,0,1,1613.816,1994.372Z",
  transform: "translate(-1358.019 -1719.919)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_762",
  "data-name": "Path 762",
  d: "M823.9,2165.676c-.012.01-.024.014-.032,0s.008-.016.014-.022.024-.015.032,0S823.9,2165.668,823.9,2165.676Z",
  transform: "translate(-584.504 -1887.718)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_763",
  "data-name": "Path 763",
  d: "M1074.72,1974.529c.01.011.014.024,0,.032s-.016-.008-.022-.014-.015-.024,0-.031S1074.712,1974.524,1074.72,1974.529Z",
  transform: "translate(-830.131 -1700.547)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_764",
  "data-name": "Path 764",
  d: "M1088.318,1980.218c0,.02-.016.024-.027.031a.024.024,0,0,1-.011,0,.026.026,0,0,1-.009-.007c0-.019.015-.024.027-.031S1088.311,1980.215,1088.318,1980.218Z",
  transform: "translate(-843.431 -1706.123)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_765",
  "data-name": "Path 765",
  d: "M1191.366,2014.126c-.011.01-.024.015-.032,0s.007-.016.014-.022.024-.015.032,0S1191.371,2014.118,1191.366,2014.126Z",
  transform: "translate(-944.359 -1739.307)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_766",
  "data-name": "Path 766",
  d: "M1275.16,2026.211l.005.037c-.009,0-.022,0-.025-.011a.156.156,0,0,1-.01-.038Z",
  transform: "translate(-1026.42 -1751.161)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_767",
  "data-name": "Path 767",
  d: "M783.213,1875.135v.025a.152.152,0,0,1-.033-.023c0-.005,0-.018,0-.027a.037.037,0,0,1,.035.025Z",
  transform: "translate(-544.658 -1603.2)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_768",
  "data-name": "Path 768",
  d: "M868.428,1949.407c0,.021-.015.025-.027.032s-.019,0-.019-.009.015-.024.026-.031S868.422,1949.4,868.428,1949.407Z",
  transform: "translate(-628.096 -1675.951)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_769",
  "data-name": "Path 769",
  d: "M527.792,2432.732c.031.031.043.058-.006.093s-.057-.007-.078-.03-.045-.06,0-.094S527.769,2432.706,527.792,2432.732Z",
  transform: "translate(-294.451 -2149.228)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_770",
  "data-name": "Path 770",
  d: "M510.05,2175.463c.018-.013.036-.035.058-.022s.018.049.016.075a.067.067,0,0,1-.017.037.068.068,0,0,1-.036.021.209.209,0,0,1-.081,0,.458.458,0,0,1,.02-.079C510.018,2175.481,510.037,2175.473,510.05,2175.463Z",
  transform: "translate(-277.13 -1897.307)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_771",
  "data-name": "Path 771",
  d: "M522.692,2339.041c.011-.03-.006-.07.032-.089a.085.085,0,0,1,.031,0c-.009.03,0,.069-.031.089a.077.077,0,0,1-.032,0Z",
  transform: "translate(-289.568 -2057.432)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_772",
  "data-name": "Path 772",
  d: "M681.26,2425.2c.029-.014.037.006.049.021a.055.055,0,0,1,.013.02.06.06,0,0,1,0,.023.059.059,0,0,1-.005.023.063.063,0,0,1-.014.02.059.059,0,0,1-.035,0,.061.061,0,0,1-.029-.02.083.083,0,0,1,.017-.087Z",
  transform: "translate(-444.829 -2141.889)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_773",
  "data-name": "Path 773",
  d: "M595.867,2266.666c.024-.017.037,0,.047.015s.037.037.006.06a.056.056,0,0,1-.034.01.055.055,0,0,1-.033-.013.056.056,0,0,1-.006-.038A.057.057,0,0,1,595.867,2266.666Z",
  transform: "translate(-361.207 -1986.639)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_774",
  "data-name": "Path 774",
  d: "M642.384,2395.84c.025.01.061,0,.075.031a.063.063,0,0,1,0,.027c-.026-.009-.06,0-.075-.03a.067.067,0,0,1,0-.028Z",
  transform: "translate(-406.779 -2113.145)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_775",
  "data-name": "Path 775",
  d: "M595.265,2374.185c0,.021-.016.025-.027.032s-.019,0-.02-.009.015-.023.027-.03S595.258,2374.183,595.265,2374.185Z",
  transform: "translate(-360.591 -2091.93)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_776",
  "data-name": "Path 776",
  d: "M1225.785,1950.973l0,.022s-.012,0-.014,0a.085.085,0,0,1,0-.022Z",
  transform: "translate(-978.083 -1677.489)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_777",
  "data-name": "Path 777",
  d: "M1093.293,2031.59l0,.015-.019-.011v-.014Z",
  transform: "translate(-848.327 -1756.429)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_778",
  "data-name": "Path 778",
  d: "M1187.083,1963.486a.048.048,0,0,1,0,.013.036.036,0,0,1-.023,0c-.012-.007-.011-.015,0-.018S1187.076,1963.484,1187.083,1963.486Z",
  transform: "translate(-940.164 -1689.741)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_779",
  "data-name": "Path 779",
  d: "M1185.49,1963.1c-.007,0-.02,0-.021-.007s0-.019.011-.015a.123.123,0,0,1,.021.014Z",
  transform: "translate(-938.615 -1689.35)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_780",
  "data-name": "Path 780",
  d: "M975.652,1120.408h-.011a.056.056,0,0,1-.039-.018.055.055,0,0,1-.015-.04.056.056,0,0,1,.018-.039.057.057,0,0,1,.04-.015.23.23,0,0,0,.2-.112.056.056,0,0,1,.077-.021.057.057,0,0,1,.026.034.056.056,0,0,1-.006.043.343.343,0,0,1-.291.168Z",
  transform: "translate(-733.081 -863.883)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_781",
  "data-name": "Path 781",
  d: "M991.869,1160.942a.614.614,0,0,1-.1-.009.056.056,0,0,1-.037-.023.055.055,0,0,1-.009-.02.056.056,0,0,1,0-.022.059.059,0,0,1,.008-.021.058.058,0,0,1,.015-.016.056.056,0,0,1,.042-.01.524.524,0,0,0,.323-.049.056.056,0,0,1,.073.026.056.056,0,0,1-.022.074.638.638,0,0,1-.288.07Z",
  transform: "translate(-748.877 -903.654)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_782",
  "data-name": "Path 782",
  d: "M850.965,1025.489a.915.915,0,0,1-.346-.011c-.411-.1-.3-.405-.057-.405s-.491-.207-.4-.548.761-.117.8-.548.087-1.116.668-.891.635-.388,1.1-.18,1.334.968.769,1.264c-.441.231-1.9.174-1.731.563.274.623.125.83.125.83s-.436-.336-.745-.183a1.5,1.5,0,0,0-.189.109Z",
  transform: "translate(-610.251 -768.604)",
  fill: "#9cbd6b"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_783",
  "data-name": "Path 783",
  d: "M849.243,1022.987a.058.058,0,0,1-.034-.011s-.411-.312-.686-.177a1.37,1.37,0,0,0-.181.1.06.06,0,0,1-.022.01.983.983,0,0,1-.37-.012c-.252-.062-.328-.2-.315-.308a.242.242,0,0,1,.184-.2c-.157-.1-.431-.272-.362-.519.054-.191.251-.234.425-.271.221-.048.356-.09.371-.267v-.018c.027-.32.065-.758.313-.912a.464.464,0,0,1,.43-.008.514.514,0,0,0,.561-.09.494.494,0,0,1,.545-.089c.336.149.975.639.987,1.035a.349.349,0,0,1-.215.329,3,3,0,0,1-.842.187c-.374.053-.8.112-.865.237a.068.068,0,0,0,0,.066c.279.635.136.862.119.886a.058.058,0,0,1-.016.015.054.054,0,0,1-.021.008Zm-.564-.334a1.073,1.073,0,0,1,.537.191,1.22,1.22,0,0,0-.149-.721.178.178,0,0,1,0-.166c.1-.172.49-.228.947-.293a3.094,3.094,0,0,0,.805-.177.242.242,0,0,0,.155-.227c-.01-.31-.557-.774-.921-.937a.383.383,0,0,0-.436.079.626.626,0,0,1-.664.1.353.353,0,0,0-.33,0c-.2.125-.235.531-.262.827v.019c-.023.272-.265.324-.46.367-.164.036-.3.066-.34.192-.048.171.184.314.323.4.09.056.135.084.12.138s-.075.052-.1.052a.148.148,0,0,0-.16.109c-.007.06.05.141.231.187a.857.857,0,0,0,.311.012,1.608,1.608,0,0,1,.187-.106.462.462,0,0,1,.205-.049Z",
  transform: "translate(-607.595 -765.973)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_784",
  "data-name": "Path 784",
  d: "M2476.089,2690.812l-.32-.162-.709.982.335.129Z",
  transform: "translate(-2201.496 -2401.848)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_785",
  "data-name": "Path 785",
  d: "M2472.688,2689.123a.063.063,0,0,1-.02,0l-.336-.129a.058.058,0,0,1-.034-.037.059.059,0,0,1,0-.025.05.05,0,0,1,.01-.023l.71-.982a.055.055,0,0,1,.071-.017l.32.161a.051.051,0,0,1,.019.016.056.056,0,0,1,.01.022.067.067,0,0,1,0,.024.057.057,0,0,1-.01.022l-.694.949a.055.055,0,0,1-.02.017.052.052,0,0,1-.025.007Zm-.248-.211.227.087.63-.862-.218-.11Z",
  transform: "translate(-2198.788 -2399.154)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_786",
  "data-name": "Path 786",
  d: "M2492.06,2696.758l-.126-.061-.694.95.641.27,1.087-1.256Z",
  transform: "translate(-2217.341 -2407.733)",
  fill: "#dc5c3f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_787",
  "data-name": "Path 787",
  d: "M2489.219,2695.322a.056.056,0,0,1-.022,0l-.642-.27a.063.063,0,0,1-.021-.015.061.061,0,0,1-.012-.022.058.058,0,0,1,0-.025.053.053,0,0,1,.01-.023l.694-.949a.054.054,0,0,1,.031-.021.056.056,0,0,1,.038,0l.112.054.892-.1a.053.053,0,0,1,.032.007.055.055,0,0,1,.023.023.05.05,0,0,1,.006.032.058.058,0,0,1-.013.03l-1.087,1.256a.063.063,0,0,1-.019.015.056.056,0,0,1-.023,0Zm-.555-.35.539.227.967-1.118-.766.083a.06.06,0,0,1-.03-.005l-.084-.041Z",
  transform: "translate(-2214.678 -2405.083)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_788",
  "data-name": "Path 788",
  d: "M477.378,1872.11h-27.1a.2.2,0,0,0,0,.4h27.1a.2.2,0,0,0,0-.4Z",
  transform: "translate(-218.455 -1600.262)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_789",
  "data-name": "Path 789",
  d: "M475.174,1869.915h-27.1a.258.258,0,0,1,0-.515h27.1a.258.258,0,0,1,0,.515Zm-27.1-.4a.146.146,0,0,0,0,.291h27.1a.146.146,0,0,0,0-.291Z",
  transform: "translate(-216.251 -1597.609)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_790",
  "data-name": "Path 790",
  d: "M568.3,2452.91a.057.057,0,0,1-.056-.056v-6.427a.055.055,0,0,1,.016-.04.056.056,0,0,1,.1.04v6.427a.057.057,0,0,1-.056.056Z",
  transform: "translate(-334.179 -2162.628)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_791",
  "data-name": "Path 791",
  d: "M527.091,2756.8H525.31a.056.056,0,0,1-.056-.056.056.056,0,0,1,.056-.056h1.781a.056.056,0,0,1,0,.112Z",
  transform: "translate(-292.076 -2466.52)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_792",
  "data-name": "Path 792",
  d: "M1225.576,2452.91a.056.056,0,0,1-.039-.017.054.054,0,0,1-.016-.04v-6.427a.054.054,0,0,1,.016-.04.056.056,0,0,1,.079,0,.055.055,0,0,1,.016.04v6.427a.056.056,0,0,1-.016.04.057.057,0,0,1-.04.017Z",
  transform: "translate(-977.838 -2162.628)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_793",
  "data-name": "Path 793",
  d: "M1619.526,2452.91a.056.056,0,0,1-.04-.017.055.055,0,0,1-.016-.04v-6.427a.055.055,0,0,1,.016-.04.057.057,0,0,1,.04-.017.056.056,0,0,1,.056.056v6.427a.057.057,0,0,1-.056.056Z",
  transform: "translate(-1363.628 -2162.628)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_794",
  "data-name": "Path 794",
  d: "M1578.3,2756.8h-1.781a.056.056,0,0,1-.04-.017.057.057,0,0,1-.016-.04.056.056,0,0,1,.056-.056h1.781a.056.056,0,0,1,.056.056.057.057,0,0,1-.056.056Z",
  transform: "translate(-1321.509 -2466.52)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_795",
  "data-name": "Path 795",
  d: "M1790.31,2759.465h-20.693a.038.038,0,0,1-.037-.037.037.037,0,0,1,.011-.027.036.036,0,0,1,.026-.011h20.693a.037.037,0,0,1,.027.011.038.038,0,0,1-.027.064Z",
  transform: "translate(-1510.628 -2469.164)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_796",
  "data-name": "Path 796",
  d: "M914.249,2759.465H904.29a.037.037,0,0,1,0-.075h9.958a.037.037,0,0,1,0,.075Z",
  transform: "translate(-663.225 -2469.164)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_797",
  "data-name": "Path 797",
  d: "M501.771,1177.832h-.015c-1.869-.5-4.524-1.463-5.951-1.98-.48-.174-.827-.3-.96-.341a1.338,1.338,0,0,0-1.073.081.056.056,0,0,1-.079,0,.059.059,0,0,1-.012-.018.056.056,0,0,1,0-.043.059.059,0,0,1,.012-.018,1.437,1.437,0,0,1,1.186-.108c.135.042.483.168.964.343,1.412.512,4.029,1.46,5.889,1.963a15.533,15.533,0,0,0,.5-3.934.057.057,0,0,1,0-.022.064.064,0,0,1,.012-.019.059.059,0,0,1,.039-.017.054.054,0,0,1,.022,0,.051.051,0,0,1,.018.012.056.056,0,0,1,.017.039,15.551,15.551,0,0,1-.523,4.02.056.056,0,0,1-.02.028.055.055,0,0,1-.032.011Z",
  transform: "translate(-261.153 -916.337)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_798",
  "data-name": "Path 798",
  d: "M1007.816,1062.385a.055.055,0,0,1-.037-.014l-1.966-1.8a.051.051,0,0,1-.015-.017.055.055,0,0,1-.007-.022.058.058,0,0,1,0-.023.051.051,0,0,1,.012-.02.056.056,0,0,1,.019-.014.054.054,0,0,1,.023,0,.06.06,0,0,1,.023,0,.059.059,0,0,1,.019.013l1.917,1.752c.173-.235,1.038-1.158,5.165-3.647,1.924-1.161,2.344-1.049,2.386-1.032a.054.054,0,0,1,.019.011.056.056,0,0,1,.013.061.057.057,0,0,1-.071.033c-.021-.006-.434-.095-2.289,1.023-4.746,2.862-5.146,3.629-5.161,3.663a.056.056,0,0,1-.016.02.058.058,0,0,1-.024.011Z",
  transform: "translate(-762.659 -802.578)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_799",
  "data-name": "Path 799",
  d: "M259.05,1174.517a.058.058,0,0,1-.028-.007.055.055,0,0,1-.02-.02.942.942,0,0,1,.361-1.273.051.051,0,0,1,.021-.006.057.057,0,0,1,.022,0,.056.056,0,0,1,.033.028.057.057,0,0,1,.006.021.054.054,0,0,1,0,.021.056.056,0,0,1-.011.02.055.055,0,0,1-.017.013.83.83,0,0,0-.316,1.116.057.057,0,0,1,.007.021.055.055,0,0,1,0,.022.055.055,0,0,1-.054.042Z",
  transform: "translate(-31.225 -915.839)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_800",
  "data-name": "Path 800",
  d: "M699.19,1538.335a.055.055,0,0,1-.031-.009.056.056,0,0,1-.024-.057.055.055,0,0,1,.015-.029,2.049,2.049,0,0,0,.547-1.135.055.055,0,0,1,.007-.021.052.052,0,0,1,.015-.017.052.052,0,0,1,.02-.01.061.061,0,0,1,.022,0,.056.056,0,0,1,.038.022.055.055,0,0,1,.01.02.058.058,0,0,1,0,.022,2.162,2.162,0,0,1-.576,1.2.052.052,0,0,1-.019.013.057.057,0,0,1-.023,0Z",
  transform: "translate(-462.354 -1272.149)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_801",
  "data-name": "Path 801",
  d: "M704.381,1581.7a.059.059,0,0,1-.031-.01.057.057,0,0,1-.02-.025.056.056,0,0,1,0-.032.055.055,0,0,1,.014-.029l.6-.629a.057.057,0,0,1,.061-.014.057.057,0,0,1,.031.03.059.059,0,0,1,0,.021.056.056,0,0,1,0,.022.057.057,0,0,1-.012.019l-.6.629A.058.058,0,0,1,704.381,1581.7Z",
  transform: "translate(-467.439 -1315.142)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_802",
  "data-name": "Path 802",
  d: "M878.3,1192.288h-.006a.056.056,0,0,1-.05-.062,5.229,5.229,0,0,0-.044-1.446.057.057,0,0,1,0-.022.055.055,0,0,1,.009-.02.057.057,0,0,1,.016-.016.057.057,0,0,1,.021-.008.057.057,0,0,1,.042.01.057.057,0,0,1,.015.016.056.056,0,0,1,.008.021,5.366,5.366,0,0,1,.045,1.476.057.057,0,0,1-.019.036.056.056,0,0,1-.038.014Z",
  transform: "translate(-637.712 -932.981)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_803",
  "data-name": "Path 803",
  d: "M1481.633,903.757a.037.037,0,0,1-.037-.034,1.339,1.339,0,0,0-.589-.976.037.037,0,0,1-.01-.01.039.039,0,0,1-.006-.013.037.037,0,0,1,.006-.028.038.038,0,0,1,.024-.016.037.037,0,0,1,.028.005,1.415,1.415,0,0,1,.623,1.031.038.038,0,0,1-.008.028.036.036,0,0,1-.011.009.037.037,0,0,1-.014,0Z",
  transform: "translate(-1228.016 -650.911)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_804",
  "data-name": "Path 804",
  d: "M1429.548,993.718a.039.039,0,0,1-.015,0,.038.038,0,0,1-.012-.009.037.037,0,0,1,0-.053,2.091,2.091,0,0,0,.554-.914.039.039,0,0,1,.018-.022.037.037,0,0,1,.028,0,.036.036,0,0,1,.022.018.038.038,0,0,1,0,.029,2.163,2.163,0,0,1-.573.948A.038.038,0,0,1,1429.548,993.718Z",
  transform: "translate(-1177.603 -739.08)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_805",
  "data-name": "Path 805",
  d: "M1427.81,991.982a.037.037,0,0,1-.02-.006.039.039,0,0,1-.014-.015.04.04,0,0,1,0-.021.035.035,0,0,1,.008-.019,1.109,1.109,0,0,0,.231-.7.036.036,0,0,1,.01-.027.037.037,0,0,1,.026-.012.038.038,0,0,1,.039.036,1.188,1.188,0,0,1-.247.753.036.036,0,0,1-.013.011A.038.038,0,0,1,1427.81,991.982Z",
  transform: "translate(-1175.901 -737.578)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_806",
  "data-name": "Path 806",
  d: "M479.3,1271.017a.034.034,0,0,1-.013,0,.043.043,0,0,1-.012-.008.035.035,0,0,1-.008-.012.037.037,0,0,1,0-.014.038.038,0,0,1,0-.015.876.876,0,0,1,.747-.542.037.037,0,0,1,.015,0,.038.038,0,0,1,.013.007.039.039,0,0,1,.009.012.038.038,0,0,1,0,.014.038.038,0,0,1,0,.015.035.035,0,0,1-.007.013.033.033,0,0,1-.012.009.035.035,0,0,1-.014,0,.811.811,0,0,0-.682.5.038.038,0,0,1-.014.017A.036.036,0,0,1,479.3,1271.017Z",
  transform: "translate(-247.043 -1011.039)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_807",
  "data-name": "Path 807",
  d: "M865.067,1211.327a.037.037,0,0,1-.037-.037v-.432a.037.037,0,0,1,.011-.027.037.037,0,0,1,.064.027v.432a.037.037,0,0,1-.037.037Z",
  transform: "translate(-624.815 -952.67)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_808",
  "data-name": "Path 808",
  d: "M1120.888,1336.786a.228.228,0,1,0-.228-.228A.228.228,0,0,0,1120.888,1336.786Z",
  transform: "translate(-875.15 -1075.58)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_809",
  "data-name": "Path 809",
  d: "M1118.24,1334.194a.284.284,0,0,1-.279-.34.282.282,0,0,1,.078-.145.284.284,0,1,1,.2.485Zm0-.456a.173.173,0,0,0-.159.106.172.172,0,0,0-.01.1.171.171,0,0,0,.234.125.172.172,0,0,0-.066-.331Z",
  transform: "translate(-872.501 -1072.932)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_810",
  "data-name": "Path 810",
  d: "M1202.458,1468.506a.228.228,0,1,0-.228-.228A.228.228,0,0,0,1202.458,1468.506Z",
  transform: "translate(-955.03 -1204.572)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_811",
  "data-name": "Path 811",
  d: "M1199.8,1465.913a.283.283,0,0,1-.262-.176.284.284,0,0,1,.207-.387.284.284,0,1,1,.055.563Zm0-.456a.172.172,0,0,0-.034.341.172.172,0,1,0,.034-.341Z",
  transform: "translate(-952.374 -1201.923)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_812",
  "data-name": "Path 812",
  d: "M1268.438,1603.516a.228.228,0,1,0-.228-.228A.228.228,0,0,0,1268.438,1603.516Z",
  transform: "translate(-1019.643 -1336.786)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_813",
  "data-name": "Path 813",
  d: "M1265.78,1600.923a.284.284,0,1,1,.2-.083A.285.285,0,0,1,1265.78,1600.923Zm0-.456a.172.172,0,1,0,.122.05A.172.172,0,0,0,1265.78,1600.467Z",
  transform: "translate(-1016.985 -1334.137)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_814",
  "data-name": "Path 814",
  d: "M706.258,1034.146a.228.228,0,1,0-.228-.228A.228.228,0,0,0,706.258,1034.146Z",
  transform: "translate(-469.108 -779.209)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_815",
  "data-name": "Path 815",
  d: "M703.608,1031.546a.284.284,0,1,1,.2-.083.284.284,0,0,1-.2.083Zm0-.456a.172.172,0,1,0,.122.05.172.172,0,0,0-.122-.05Z",
  transform: "translate(-466.459 -776.553)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_816",
  "data-name": "Path 816",
  d: "M772.743,1039.876a.228.228,0,1,0-.228-.228A.228.228,0,0,0,772.743,1039.876Z",
  transform: "translate(-534.216 -784.82)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_817",
  "data-name": "Path 817",
  d: "M770.093,1037.284a.284.284,0,1,1,.262-.176.28.28,0,0,1-.062.092.287.287,0,0,1-.092.062A.291.291,0,0,1,770.093,1037.284Zm0-.456a.172.172,0,1,0,.121.05A.171.171,0,0,0,770.093,1036.828Z",
  transform: "translate(-531.566 -782.172)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_818",
  "data-name": "Path 818",
  d: "M1045.908,999.952a.228.228,0,1,0-.228-.228A.228.228,0,0,0,1045.908,999.952Z",
  transform: "translate(-801.723 -745.723)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_819",
  "data-name": "Path 819",
  d: "M1043.26,997.358a.284.284,0,1,1,.2-.083.284.284,0,0,1-.2.083Zm0-.456a.171.171,0,0,0-.159.106.172.172,0,0,0,.225.225.175.175,0,0,0,.077-.063.172.172,0,0,0-.143-.268Z",
  transform: "translate(-799.074 -743.073)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_820",
  "data-name": "Path 820",
  d: "M1104.058,962.679a.228.228,0,1,0-.228-.228A.228.228,0,0,0,1104.058,962.679Z",
  transform: "translate(-858.668 -709.222)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_821",
  "data-name": "Path 821",
  d: "M1101.409,960.084a.284.284,0,0,1-.278-.339.28.28,0,0,1,.078-.145.284.284,0,1,1,.2.485Zm0-.456a.171.171,0,0,0-.159.106.171.171,0,0,0,.037.187.171.171,0,1,0,.121-.292Z",
  transform: "translate(-856.02 -706.571)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_822",
  "data-name": "Path 822",
  d: "M837.62,1047.966a.228.228,0,1,0-.228-.228A.228.228,0,0,0,837.62,1047.966Z",
  transform: "translate(-597.749 -792.743)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_823",
  "data-name": "Path 823",
  d: "M834.97,1045.364a.284.284,0,1,1,.2-.083A.284.284,0,0,1,834.97,1045.364Zm0-.456a.172.172,0,0,0-.169.205.172.172,0,1,0,.169-.205Z",
  transform: "translate(-595.099 -790.084)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_824",
  "data-name": "Path 824",
  d: "M1332.138,1761.916a.228.228,0,1,0-.228-.228A.228.228,0,0,0,1332.138,1761.916Z",
  transform: "translate(-1082.024 -1491.904)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_825",
  "data-name": "Path 825",
  d: "M1329.489,1759.324a.285.285,0,1,1,.2-.083A.285.285,0,0,1,1329.489,1759.324Zm0-.456a.172.172,0,0,0-.169.205.172.172,0,0,0,.135.135.17.17,0,0,0,.1-.01.171.171,0,0,0-.066-.329Z",
  transform: "translate(-1079.376 -1489.256)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_826",
  "data-name": "Path 826",
  d: "M1378.778,1253.505a.057.057,0,0,1-.051-.031,3.084,3.084,0,0,1-.252-2.089.057.057,0,0,1,.027-.033.056.056,0,0,1,.081.065,3.028,3.028,0,0,0,.246,2.008.057.057,0,0,1,0,.043.056.056,0,0,1-.028.032.058.058,0,0,1-.025.006Z",
  transform: "translate(-1127.547 -992.355)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_827",
  "data-name": "Path 827",
  d: "M1393.323,1262.876a.056.056,0,0,1-.056-.054,1.171,1.171,0,0,1,.175-.663.058.058,0,0,1,.035-.023.056.056,0,0,1,.06.082,1.06,1.06,0,0,0-.159.6.057.057,0,0,1,0,.022.054.054,0,0,1-.011.019.054.054,0,0,1-.018.013.057.057,0,0,1-.021.005Z",
  transform: "translate(-1142.11 -1002.922)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_828",
  "data-name": "Path 828",
  d: "M803.337,1297.371a3.7,3.7,0,0,0,.166,2.176c.506-.172,1.745-1.053,2.583-1.4.3-2.145,3.1-5.912,2.25-9.1-.187-.7-.338-.839-.432-.91A17.7,17.7,0,0,1,803.337,1297.371Z",
  transform: "translate(-564.297 -1028.388)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_829",
  "data-name": "Path 829",
  d: "M1621.621,1722.147c-.3-.187-.673.224-1.046.374a.506.506,0,0,1-.5-.152,7.871,7.871,0,0,0,.683,2.78l1.676.066a7.66,7.66,0,0,0,.716-2.833.811.811,0,0,1-.254.179C1622.368,1722.782,1622.032,1722.371,1621.621,1722.147Z",
  transform: "translate(-1364.215 -1453.359)",
  fill: "#dc5c3f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_830",
  "data-name": "Path 830",
  d: "M1619.873,1722.582l-1.677-.064a.055.055,0,0,1-.047-.03,7.91,7.91,0,0,1-.689-2.8.056.056,0,0,1,.031-.055.057.057,0,0,1,.033-.005.056.056,0,0,1,.03.015.453.453,0,0,0,.448.141,2.374,2.374,0,0,0,.348-.192c.253-.158.514-.321.747-.178.1.055.2.12.288.183.289.2.56.384.934.224a.777.777,0,0,0,.237-.167.057.057,0,0,1,.03-.016.056.056,0,0,1,.058.027.055.055,0,0,1,.007.033,7.681,7.681,0,0,1-.723,2.856.058.058,0,0,1-.023.024.056.056,0,0,1-.033.007Zm-1.642-.174,1.609.061a7.46,7.46,0,0,0,.679-2.641.79.79,0,0,1-.163.1,1.008,1.008,0,0,1-1.04-.236c-.09-.062-.184-.126-.279-.178h0c-.173-.108-.394.03-.628.177a2.451,2.451,0,0,1-.368.2.5.5,0,0,1-.457-.079,7.71,7.71,0,0,0,.649,2.6Z",
  transform: "translate(-1361.659 -1450.672)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_831",
  "data-name": "Path 831",
  d: "M1617.56,1688.92c.007.329.025.649.053.956a.506.506,0,0,0,.5.153c.374-.15.747-.561,1.046-.374.411.224.747.635,1.271.411a.814.814,0,0,0,.254-.178c.029-.311.047-.635.054-.968Z",
  transform: "translate(-1361.757 -1420.867)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_832",
  "data-name": "Path 832",
  d: "M1617.451,1687.464a1.311,1.311,0,0,1-.72-.305c-.091-.062-.184-.125-.279-.178-.176-.109-.4.029-.631.175a2.439,2.439,0,0,1-.367.2.556.556,0,0,1-.563-.164.055.055,0,0,1-.018-.037c-.028-.313-.046-.635-.053-.96a.052.052,0,0,1,0-.022.05.05,0,0,1,.012-.018.057.057,0,0,1,.018-.012.054.054,0,0,1,.021,0h3.183a.055.055,0,0,1,.022,0,.054.054,0,0,1,.018.012.057.057,0,0,1,.016.04c-.007.327-.025.654-.054.972a.056.056,0,0,1-.017.035.874.874,0,0,1-.271.191.8.8,0,0,1-.32.07Zm-1.139-.635a.362.362,0,0,1,.2.057c.1.053.193.119.286.182.289.2.561.384.934.224a.743.743,0,0,0,.224-.153c.026-.29.043-.587.051-.886h-3.071c.007.295.024.588.049.874a.439.439,0,0,0,.431.126,2.333,2.333,0,0,0,.348-.192,1.167,1.167,0,0,1,.551-.233Z",
  transform: "translate(-1359.073 -1418.145)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_833",
  "data-name": "Path 833",
  d: "M1728.01,1558.567l.894-2.757h.252l-.909,2.757Z",
  transform: "translate(-1469.92 -1290.514)",
  fill: "#34728c"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_834",
  "data-name": "Path 834",
  d: "M1725.6,1556.038h-.237a.053.053,0,0,1-.026-.006.056.056,0,0,1-.02-.017.054.054,0,0,1-.008-.05l.894-2.757a.054.054,0,0,1,.021-.027.057.057,0,0,1,.033-.01h.252a.06.06,0,0,1,.026.006.058.058,0,0,1,.02.017.064.064,0,0,1,.01.024.059.059,0,0,1,0,.026l-.909,2.755a.058.058,0,0,1-.021.028.056.056,0,0,1-.033.01Zm-.159-.112h.119l.873-2.644h-.134Z",
  transform: "translate(-1467.276 -1287.929)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_835",
  "data-name": "Path 835",
  d: "M1750.641,1724.272h-.016a.345.345,0,0,1-.24-.112.243.243,0,0,1-.051-.085.247.247,0,0,1-.012-.1c.015-.157.17-.239.3-.293l.486-.2a1.485,1.485,0,0,0,.79-.539.748.748,0,0,0-.239-.969.7.7,0,0,0-.92.141.056.056,0,0,1-.036.021.057.057,0,0,1-.04-.009.056.056,0,0,1-.023-.034.057.057,0,0,1,.006-.041.806.806,0,0,1,1.072-.173A.857.857,0,0,1,1752,1723a1.629,1.629,0,0,1-.844.587l-.486.2c-.1.042-.224.1-.233.2a.127.127,0,0,0,.008.053.131.131,0,0,0,.028.046.233.233,0,0,0,.16.075.67.67,0,0,0,.33-.114.056.056,0,0,1,.041,0,.057.057,0,0,1,.037.067.057.057,0,0,1-.024.033A.8.8,0,0,1,1750.641,1724.272Z",
  transform: "translate(-1491.77 -1453.021)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_836",
  "data-name": "Path 836",
  d: "M1762.67,1516.872a.475.475,0,0,0-.219-.617c-.2-.059-.434.122-.515.4a.476.476,0,0,0,.219.617C1762.358,1517.335,1762.589,1517.154,1762.67,1516.872Z",
  transform: "translate(-1503.115 -1251.768)",
  fill: "#34728c"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_837",
  "data-name": "Path 837",
  d: "M1759.673,1514.777a.328.328,0,0,1-.093-.014.529.529,0,0,1-.257-.686.7.7,0,0,1,.231-.359.367.367,0,0,1,.606.177.7.7,0,0,1,0,.426A.578.578,0,0,1,1759.673,1514.777Zm.14-1.043a.312.312,0,0,0-.19.075.587.587,0,0,0-.193.3c-.075.252.008.5.181.547s.374-.112.446-.366a.589.589,0,0,0,0-.357.282.282,0,0,0-.179-.19.229.229,0,0,0-.065-.01Z",
  transform: "translate(-1500.554 -1249.2)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_838",
  "data-name": "Path 838",
  d: "M936.5,1195.531h0a.978.978,0,0,1-.3-.112.013.013,0,0,1-.006-.008.014.014,0,0,1,0-.011.013.013,0,0,1,.008-.006.014.014,0,0,1,.011,0,.946.946,0,0,0,.295.109.014.014,0,0,1,.009.006.013.013,0,0,1,0,.01.012.012,0,0,1,0,.008.013.013,0,0,1-.009,0Z",
  transform: "translate(-694.499 -937.563)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_839",
  "data-name": "Path 839",
  d: "M953.258,1207.672a2.13,2.13,0,0,1-.561-.145l0,0,0,0a.014.014,0,0,1,0-.005.015.015,0,0,1,0-.005l0,0,0,0h.011a2.123,2.123,0,0,0,.554.143.013.013,0,0,1,.009.005.014.014,0,0,1,0,.02.014.014,0,0,1-.011,0Z",
  transform: "translate(-710.658 -949.419)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_840",
  "data-name": "Path 840",
  d: "M971.5,1208.134l-.112-.011h-.006l-.005,0,0-.005a.012.012,0,0,1,0-.006.013.013,0,0,1,0-.006l0,0,.006,0h.006l.112.011.005,0,0,0,0,0a.013.013,0,0,1,0,.005.013.013,0,0,1-.005.009A.012.012,0,0,1,971.5,1208.134Z",
  transform: "translate(-728.958 -950.001)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_841",
  "data-name": "Path 841",
  d: "M2600.044,2687.608l-.265-.238-.729,1.009.314.158Z",
  transform: "translate(-2322.917 -2398.636)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_842",
  "data-name": "Path 842",
  d: "M2596.708,2685.942a.052.052,0,0,1-.025-.006l-.315-.158a.059.059,0,0,1-.019-.015.055.055,0,0,1-.01-.021.051.051,0,0,1,0-.024.055.055,0,0,1,.009-.022l.729-1.009a.059.059,0,0,1,.017-.015.053.053,0,0,1,.021-.008.061.061,0,0,1,.023,0,.053.053,0,0,1,.02.012l.265.238a.055.055,0,0,1,.008.075l-.679.929a.057.057,0,0,1-.043.023Zm-.231-.235.214.108.622-.85-.181-.162Z",
  transform: "translate(-2320.261 -2395.986)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_843",
  "data-name": "Path 843",
  d: "M2615.013,2698.708l-.1-.093-.679.93.566.284,1.125-1.219Z",
  transform: "translate(-2337.783 -2409.643)",
  fill: "#dc5c3f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_844",
  "data-name": "Path 844",
  d: "M2612.149,2697.147a.055.055,0,0,1-.025-.006l-.566-.284a.058.058,0,0,1-.019-.015.06.06,0,0,1-.01-.022.058.058,0,0,1,0-.024.051.051,0,0,1,.01-.022l.679-.929a.063.063,0,0,1,.018-.016.059.059,0,0,1,.022-.007.051.051,0,0,1,.023,0,.05.05,0,0,1,.02.012l.085.074.883-.095a.052.052,0,0,1,.033.007.055.055,0,0,1,.029.057.058.058,0,0,1-.014.03l-1.125,1.219a.051.051,0,0,1-.018.014.056.056,0,0,1-.022.005Zm-.482-.361.469.236.994-1.078-.76.082a.053.053,0,0,1-.023,0,.056.056,0,0,1-.02-.011l-.057-.051Z",
  transform: "translate(-2335.136 -2406.905)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_845",
  "data-name": "Path 845",
  d: "M2397.54,2650.938h0a.018.018,0,0,1-.008-.007.016.016,0,0,1,0-.011,2.366,2.366,0,0,1,.461-.866.015.015,0,0,1,.01,0,.014.014,0,0,1,.01,0l0,0a.009.009,0,0,1,0,.005.009.009,0,0,1,0,.005.01.01,0,0,1,0,0,2.332,2.332,0,0,0-.456.856.012.012,0,0,1,0,.005l-.007,0Z",
  transform: "translate(-2125.568 -2362.089)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_846",
  "data-name": "Path 846",
  d: "M2413.208,2677.513h-.007l0,0,0,0a.026.026,0,0,1,0-.006l0-.005.131-.233,0,0,.005,0h.011a.015.015,0,0,1,.007.008.013.013,0,0,1,0,.011l-.131.233a.012.012,0,0,1-.006,0Z",
  transform: "translate(-2140.911 -2388.729)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_847",
  "data-name": "Path 847",
  d: "M2431.744,2628.344h-.005l0,0,0,0a.014.014,0,0,1,0-.005.014.014,0,0,1,0-.006,3.406,3.406,0,0,1,.471-.754.014.014,0,0,1,.01,0,.014.014,0,0,1,.01,0,.015.015,0,0,1,.005.01.014.014,0,0,1,0,.01,3.369,3.369,0,0,0-.467.747.017.017,0,0,1-.005.006l-.008,0Z",
  transform: "translate(-2159.063 -2340.071)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_848",
  "data-name": "Path 848",
  d: "M2440.812,2612.926h-.005a.014.014,0,0,1-.008-.008.016.016,0,0,1,0-.011.762.762,0,0,1,.288-.336l.005,0h.006l0,0,0,0a.015.015,0,0,1,0,.011.012.012,0,0,1-.006.009.724.724,0,0,0-.276.322.012.012,0,0,1,0,.006.015.015,0,0,1-.008,0Z",
  transform: "translate(-2167.943 -2325.384)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_849",
  "data-name": "Path 849",
  d: "M2470.456,2582.094a.018.018,0,0,1-.009,0,.015.015,0,0,1-.006-.01.014.014,0,0,1,0-.01,1.428,1.428,0,0,1,.371-.334l0,0h.006l0,0,0,0a.015.015,0,0,1,0,.01.014.014,0,0,1-.006.009,1.415,1.415,0,0,0-.364.328l-.005,0Z",
  transform: "translate(-2196.973 -2295.189)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_850",
  "data-name": "Path 850",
  d: "M2467.19,2606.344h-.007l0,0,0,0a.015.015,0,0,1,0-.006.014.014,0,0,1,0,0,.615.615,0,0,1,.147-.181l0,0h.011l0,0a.014.014,0,0,1,0,.01.016.016,0,0,1,0,.01.591.591,0,0,0-.141.173.015.015,0,0,1-.006.006Z",
  transform: "translate(-2193.775 -2319.089)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_851",
  "data-name": "Path 851",
  d: "M2461.049,2567.246a.013.013,0,0,1-.008,0,.014.014,0,0,1,0-.02,2.156,2.156,0,0,1,.632-.526l.005,0h.006l.006,0,0,0a.009.009,0,0,1,0,.006.011.011,0,0,1,0,.006.013.013,0,0,1,0,.006l0,0a2.127,2.127,0,0,0-.624.519l0,0Z",
  transform: "translate(-2187.762 -2280.46)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_852",
  "data-name": "Path 852",
  d: "M2647.952,2646.68a.044.044,0,0,1-.018,0,.039.039,0,0,1-.018-.022.038.038,0,0,1,0-.028l.014-.03a2.538,2.538,0,0,1-.059-.481.92.92,0,0,1,.144-.519.18.18,0,0,1,.178-.1c.093.021.117.13.109.224a2.1,2.1,0,0,1-.174.624,1.625,1.625,0,0,1,1.236-.5.032.032,0,0,1,.014,0,.039.039,0,0,1,.021.036.038.038,0,0,1,0,.014.034.034,0,0,1-.009.012.036.036,0,0,1-.012.007.037.037,0,0,1-.014,0,1.546,1.546,0,0,0-1.35.7l0,.011a.047.047,0,0,1,0,.014.03.03,0,0,1-.006.013.034.034,0,0,1-.01.01.04.04,0,0,1-.014.006h-.009A.04.04,0,0,1,2647.952,2646.68Zm.217-1.11c-.04,0-.079.051-.09.068a.841.841,0,0,0-.131.476,2.038,2.038,0,0,0,.039.367,2.318,2.318,0,0,0,.242-.766c0-.049,0-.134-.052-.145Z",
  transform: "translate(-2370.73 -2357.629)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_853",
  "data-name": "Path 853",
  d: "M825.533,1787.868l-.007,0-.005-.005a.013.013,0,0,1,0-.005.013.013,0,0,1,0-.005l0,0,0,0,.794-.46a.013.013,0,0,1,.011,0,.014.014,0,0,1,.009.006.015.015,0,0,1,0,.011.013.013,0,0,1-.007.009l-.794.46-.007,0Z",
  transform: "translate(-586.122 -1517.288)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_854",
  "data-name": "Path 854",
  d: "M866.742,1789.453h-.006l-.005,0a.014.014,0,0,1,0-.01.013.013,0,0,1,.006-.009,1.288,1.288,0,0,1,.324-.192.015.015,0,0,1,.011,0,.015.015,0,0,1,.008.008.016.016,0,0,1,0,.005.015.015,0,0,1,0,.005l0,0,0,0a1.242,1.242,0,0,0-.317.187.016.016,0,0,1-.01,0Z",
  transform: "translate(-626.478 -1519.105)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_855",
  "data-name": "Path 855",
  d: "M829.8,1814.444l-.007,0,0-.005a.014.014,0,0,1,0-.005.014.014,0,0,1,0-.006l0,0,0,0,.2-.112.005,0H830l0,0,0,0a.014.014,0,0,1,0,.005.017.017,0,0,1,0,.006l0,.005,0,0-.2.112Z",
  transform: "translate(-590.302 -1543.654)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_856",
  "data-name": "Path 856",
  d: "M908.883,1752.2a.014.014,0,0,1-.008,0,.016.016,0,0,1-.005-.007.015.015,0,0,1,0-.005.013.013,0,0,1,0-.005l0,0,0,0a.775.775,0,0,0,.533-.523l0-.005,0,0,.005,0h.005a.015.015,0,0,1,.008.007.015.015,0,0,1,0,.011.8.8,0,0,1-.553.543Z",
  transform: "translate(-667.745 -1482.284)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_857",
  "data-name": "Path 857",
  d: "M927.41,1688.31h0a.014.014,0,0,1-.01-.017,7.108,7.108,0,0,1,.454-1.225l0,0,0,0h.011l0,0,0,0a.012.012,0,0,1,0,.005.014.014,0,0,1,0,.005,7.079,7.079,0,0,0-.452,1.22.016.016,0,0,1-.005.007l-.009,0Z",
  transform: "translate(-685.889 -1419.046)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_858",
  "data-name": "Path 858",
  d: "M952.21,1687.508h-.005a.014.014,0,0,1-.008-.008.014.014,0,0,1,0-.011l.121-.31,0,0,0,0h.011a.015.015,0,0,1,.008.018l-.121.31a.014.014,0,0,1-.005.006l-.008,0Z",
  transform: "translate(-710.176 -1419.153)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_859",
  "data-name": "Path 859",
  d: "M1042.656,1390.991h0a.015.015,0,0,1-.009-.006.016.016,0,0,1,0-.01l.078-.443a.015.015,0,0,1,.006-.009.013.013,0,0,1,.011,0,.014.014,0,0,1,.009.006.014.014,0,0,1,0,.01l-.078.443a.017.017,0,0,1-.005.008.015.015,0,0,1-.009,0Z",
  transform: "translate(-798.747 -1128.648)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_860",
  "data-name": "Path 860",
  d: "M1036.974,1437.861h0a.014.014,0,0,1-.009-.006.014.014,0,0,1,0-.01l.133-.687a.017.017,0,0,1,.006-.008.016.016,0,0,1,.01,0,.014.014,0,0,1,.011.015l-.133.686a.014.014,0,0,1-.005.008A.014.014,0,0,1,1036.974,1437.861Z",
  transform: "translate(-793.184 -1174.311)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_861",
  "data-name": "Path 861",
  d: "M1022.543,1480.1h0l0,0,0,0a.009.009,0,0,1,0-.005.013.013,0,0,1,0-.005l.064-.255a.014.014,0,0,1,.006-.009.015.015,0,0,1,.011,0l0,0,0,0a.012.012,0,0,1,0,.005.013.013,0,0,1,0,.006l-.064.255a.015.015,0,0,1-.005.007.014.014,0,0,1-.009,0Z",
  transform: "translate(-779.051 -1216.097)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_862",
  "data-name": "Path 862",
  d: "M1013.567,1497.346h-.007a.014.014,0,0,1-.006-.009.014.014,0,0,1,0-.011,2.638,2.638,0,0,0,.309-.812.012.012,0,0,1,0,0l0,0,.005,0h.006a.015.015,0,0,1,.009.006.016.016,0,0,1,0,.011,2.663,2.663,0,0,1-.312.822l-.006,0Z",
  transform: "translate(-770.261 -1232.436)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_863",
  "data-name": "Path 863",
  d: "M992.785,1547.336h-.007a.014.014,0,0,1-.006-.008.015.015,0,0,1,0-.011,2.281,2.281,0,0,0,.227-.592l0,0,0,0,.005,0h.006a.014.014,0,0,1,.01.017,2.313,2.313,0,0,1-.23.6l-.005.005-.007,0Z",
  transform: "translate(-749.909 -1281.606)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_864",
  "data-name": "Path 864",
  d: "M978.1,1577.582H978.1a.015.015,0,0,1-.007-.008.014.014,0,0,1,0-.011,11.41,11.41,0,0,1,.533-1.146.016.016,0,0,1,.008-.007.015.015,0,0,1,.011,0,.015.015,0,0,1,.007.009.015.015,0,0,1,0,.011,11.314,11.314,0,0,0-.532,1.142.012.012,0,0,1-.005.007l-.008,0Z",
  transform: "translate(-735.534 -1310.687)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_865",
  "data-name": "Path 865",
  d: "M960.288,1624.67h0a.016.016,0,0,1-.008-.007.014.014,0,0,1,0-.011,2.418,2.418,0,0,1,.244-.513.015.015,0,0,1,.009-.006.014.014,0,0,1,.011,0,.014.014,0,0,1,.006.009.014.014,0,0,1,0,.011,2.363,2.363,0,0,0-.242.506.014.014,0,0,1-.005.007.013.013,0,0,1-.008,0Z",
  transform: "translate(-718.085 -1357.422)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_866",
  "data-name": "Path 866",
  d: "M956.977,1653.505h0l0,0,0,0a.017.017,0,0,1,0-.005.016.016,0,0,1,0-.005,1.461,1.461,0,0,1,.247-.492.016.016,0,0,1,.009-.005.015.015,0,0,1,.01,0l0,0,0,.005a.015.015,0,0,1,0,.006.012.012,0,0,1,0,0,1.437,1.437,0,0,0-.243.482.015.015,0,0,1-.005.007.012.012,0,0,1-.008,0Z",
  transform: "translate(-714.843 -1385.682)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_867",
  "data-name": "Path 867",
  d: "M883.266,1764.849a.017.017,0,0,1-.01,0,.015.015,0,0,1-.005-.009.013.013,0,0,1,0-.01.013.013,0,0,1,.009-.006,1.856,1.856,0,0,0,.267-.157,1.72,1.72,0,0,1,.274-.161.015.015,0,0,1,.011,0,.016.016,0,0,1,.007.008.015.015,0,0,1,0,.011.016.016,0,0,1-.008.007,1.872,1.872,0,0,0-.267.157,1.819,1.819,0,0,1-.274.161Z",
  transform: "translate(-642.658 -1494.884)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_868",
  "data-name": "Path 868",
  d: "M939.828,1732.229h-.006a.014.014,0,0,1-.006-.019l.023-.044a.015.015,0,0,1,.008-.006.015.015,0,0,1,.01,0,.015.015,0,0,1,.007.008.014.014,0,0,1,0,.01l-.023.044-.006,0Z",
  transform: "translate(-698.05 -1463.211)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_869",
  "data-name": "Path 869",
  d: "M1634.806,1694.989a.038.038,0,0,1-.026-.01.037.037,0,0,1-.012-.025.042.042,0,0,1,0-.014.037.037,0,0,1,.007-.013.038.038,0,0,1,.012-.009.035.035,0,0,1,.014,0l.531-.03a.036.036,0,0,1,.014,0,.032.032,0,0,1,.013.008.034.034,0,0,1,.009.011.041.041,0,0,1,0,.014.038.038,0,0,1-.01.026.036.036,0,0,1-.025.012l-.532.031Z",
  transform: "translate(-1378.609 -1426.708)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_870",
  "data-name": "Path 870",
  d: "M1646.167,1706.435h-.1a.038.038,0,0,1-.026-.011.037.037,0,0,1,.026-.064h.1a.038.038,0,0,1,.038.037.038.038,0,0,1-.038.037Z",
  transform: "translate(-1389.638 -1437.946)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_871",
  "data-name": "Path 871",
  d: "M1700.413,1848.623a.037.037,0,0,1-.022-.008.039.039,0,0,1-.014-.019.037.037,0,0,1,0-.023.038.038,0,0,1,.015-.019.5.5,0,0,1,.4-.064.037.037,0,0,1,.013.006.043.043,0,0,1,.01.011.038.038,0,0,1,0,.014.039.039,0,0,1,0,.015.034.034,0,0,1-.007.013.037.037,0,0,1-.011.01.036.036,0,0,1-.014,0,.037.037,0,0,1-.015,0,.423.423,0,0,0-.336.055A.038.038,0,0,1,1700.413,1848.623Z",
  transform: "translate(-1442.857 -1577.116)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_872",
  "data-name": "Path 872",
  d: "M535.973,1924.518l-1.262-.033a.037.037,0,0,1-.026-.011.038.038,0,0,1-.011-.026.038.038,0,0,1,.011-.027.037.037,0,0,1,.026-.011l1.262.033a.038.038,0,0,1,.037.037.038.038,0,0,1-.011.026.036.036,0,0,1-.026.011Z",
  transform: "translate(-301.3 -1651.479)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_873",
  "data-name": "Path 873",
  d: "M624.685,1959.815h-.166a.038.038,0,0,1-.037-.038.038.038,0,0,1,.011-.026.037.037,0,0,1,.026-.011h.166a.037.037,0,0,1,.026.011.038.038,0,0,1,.011.026.037.037,0,0,1-.037.038Z",
  transform: "translate(-389.249 -1686.078)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_874",
  "data-name": "Path 874",
  d: "M1185.735,2224.188l-1.528-.033a.038.038,0,0,1-.037-.037.037.037,0,0,1,.011-.027.036.036,0,0,1,.026-.011l1.528.033a.037.037,0,0,1,.026.011.036.036,0,0,1,.011.026.037.037,0,0,1-.037.037Z",
  transform: "translate(-937.344 -1944.942)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_875",
  "data-name": "Path 875",
  d: "M1245.247,2246.875h-.1a.038.038,0,0,1-.026-.064.04.04,0,0,1,.026-.011h.1a.041.041,0,0,1,.026.011.038.038,0,0,1,0,.053A.038.038,0,0,1,1245.247,2246.875Z",
  transform: "translate(-997.022 -1967.191)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_876",
  "data-name": "Path 876",
  d: "M1543.407,1967.556a.037.037,0,0,1-.026-.011.036.036,0,0,1-.011-.026.037.037,0,0,1,.037-.038l1.1-.022a.038.038,0,0,1,.026.011.038.038,0,0,1,.011.026.038.038,0,0,1-.011.027.037.037,0,0,1-.026.011Z",
  transform: "translate(-1289.104 -1693.638)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_877",
  "data-name": "Path 877",
  d: "M1573.757,2384.227a.037.037,0,0,1-.024-.009.037.037,0,0,1-.013-.022.036.036,0,0,1,0-.025.038.038,0,0,1,.02-.017,1.715,1.715,0,0,1,.851-.091l.014,0a.039.039,0,0,1,.011.01.044.044,0,0,1,.006.013.033.033,0,0,1,0,.015.036.036,0,0,1,0,.014.055.055,0,0,1-.01.011l-.013.006h-.015a1.635,1.635,0,0,0-.814.087.036.036,0,0,1-.013,0Z",
  transform: "translate(-1318.825 -2101.594)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_878",
  "data-name": "Path 878",
  d: "M1572.524,1993.566a.057.057,0,0,1-.061-.052.058.058,0,0,1,.013-.041.057.057,0,0,1,.038-.02,6.311,6.311,0,0,1,1.848-.026.056.056,0,0,1,.037.021.056.056,0,0,1-.01.079.055.055,0,0,1-.042.012,6.207,6.207,0,0,0-1.815.026Z",
  transform: "translate(-1317.595 -1719.014)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_879",
  "data-name": "Path 879",
  d: "M621.758,2409.3a.056.056,0,0,1-.06-.052.055.055,0,0,1,.014-.041.054.054,0,0,1,.038-.02l.2-.031a.055.055,0,0,1,.042.01.056.056,0,0,1,.023.037.057.057,0,0,1-.01.042.056.056,0,0,1-.037.022l-.2.031Z",
  transform: "translate(-386.522 -2126.187)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_880",
  "data-name": "Path 880",
  d: "M1687.657,978.64h-8.869a.449.449,0,0,0-.448.448v5.089a.449.449,0,0,0,.448.448h8.869a.448.448,0,0,0,.448-.448v-5.089A.448.448,0,0,0,1687.657,978.64Z",
  transform: "translate(-1421.278 -725.299)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_881",
  "data-name": "Path 881",
  d: "M1683.681,980.735h-8.868a.533.533,0,0,1-.532-.533v-5.09a.533.533,0,0,1,.532-.532h8.868a.533.533,0,0,1,.532.532V980.2a.533.533,0,0,1-.532.534Zm-8.868-5.987a.365.365,0,0,0-.364.364V980.2a.365.365,0,0,0,.364.364h8.868a.365.365,0,0,0,.364-.364v-5.089a.365.365,0,0,0-.364-.364Z",
  transform: "translate(-1417.302 -721.323)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_882",
  "data-name": "Path 882",
  d: "M1340.317,620.535H1336a.449.449,0,0,0-.448.448v2.093a.449.449,0,0,0,.448.448h4.319a.448.448,0,0,0,.448-.448v-2.093A.448.448,0,0,0,1340.317,620.535Z",
  transform: "translate(-1085.589 -374.611)",
  fill: "#34728c"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_883",
  "data-name": "Path 883",
  d: "M1337.673,620.93h-4.318a.505.505,0,0,1-.5-.5v-2.093a.505.505,0,0,1,.5-.5h4.318a.506.506,0,0,1,.5.5v2.093a.505.505,0,0,1-.5.5Zm-4.318-2.99a.392.392,0,0,0-.392.392v2.093a.392.392,0,0,0,.392.392h4.318a.393.393,0,0,0,.393-.392v-2.093a.393.393,0,0,0-.393-.392Z",
  transform: "translate(-1082.944 -371.961)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_884",
  "data-name": "Path 884",
  d: "M1902.817,620.535H1898.5a.448.448,0,0,0-.448.448v2.093a.448.448,0,0,0,.448.448h4.319a.448.448,0,0,0,.448-.448v-2.093A.448.448,0,0,0,1902.817,620.535Z",
  transform: "translate(-1636.438 -374.611)",
  fill: "#34728c"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_885",
  "data-name": "Path 885",
  d: "M1900.162,620.93h-4.317a.5.5,0,0,1-.5-.5v-2.093a.5.5,0,0,1,.5-.5h4.317a.506.506,0,0,1,.5.5v2.093a.505.505,0,0,1-.5.5Zm-4.318-2.99a.393.393,0,0,0-.393.392v2.093a.393.393,0,0,0,.393.392h4.318a.393.393,0,0,0,.392-.392v-2.093a.393.393,0,0,0-.392-.392Z",
  transform: "translate(-1633.784 -371.961)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_886",
  "data-name": "Path 886",
  d: "M1637.875,445.729h-3.953a.282.282,0,0,0-.283.283v.8a.282.282,0,0,0,.283.283h3.953a.283.283,0,0,0,.282-.283v-.8A.283.283,0,0,0,1637.875,445.729Z",
  transform: "translate(-1377.504 -203.426)",
  fill: "#9cbd6b"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_887",
  "data-name": "Path 887",
  d: "M1635.222,444.5h-3.953a.34.34,0,0,1-.339-.339v-.8a.34.34,0,0,1,.339-.339h3.953a.339.339,0,0,1,.336.339v.8a.339.339,0,0,1-.336.339Zm-3.953-1.362a.227.227,0,0,0-.227.226v.8a.227.227,0,0,0,.227.226h3.953a.226.226,0,0,0,.224-.226v-.8a.226.226,0,0,0-.224-.226Z",
  transform: "translate(-1374.851 -200.776)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_888",
  "data-name": "Path 888",
  d: "M1478.926,499.895a.058.058,0,0,1-.021,0,.055.055,0,0,1-.019-.012.054.054,0,0,1-.017-.041.059.059,0,0,1,0-.022,2.975,2.975,0,0,1,1.747-1.682.056.056,0,0,1,.022,0,.055.055,0,0,1,.021.005.057.057,0,0,1,.029.032.059.059,0,0,1,0,.022.058.058,0,0,1-.005.021.056.056,0,0,1-.013.018.053.053,0,0,1-.019.011,2.86,2.86,0,0,0-1.682,1.619.056.056,0,0,1-.02.026.057.057,0,0,1-.031.01Z",
  transform: "translate(-1225.939 -254.743)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_889",
  "data-name": "Path 889",
  d: "M1916.406,494.962a.056.056,0,0,1-.056-.049,1.991,1.991,0,0,0-1.174-1.54.058.058,0,0,1-.019-.012.053.053,0,0,1-.012-.018.049.049,0,0,1,0-.022.052.052,0,0,1,0-.022.053.053,0,0,1,.013-.019.058.058,0,0,1,.019-.012.056.056,0,0,1,.044,0,2.105,2.105,0,0,1,1.241,1.629.057.057,0,0,1-.011.041.055.055,0,0,1-.037.021Z",
  transform: "translate(-1653.174 -249.978)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_890",
  "data-name": "Path 890",
  d: "M2027.055,790.582h0a.056.056,0,0,1-.039-.018.055.055,0,0,1-.015-.04c.013-.4.006-.867,0-1.316s-.013-.916,0-1.322a.056.056,0,0,1,.058-.054.056.056,0,0,1,.054.058c-.013.4-.007.867,0,1.316s.013.916,0,1.322a.058.058,0,0,1-.017.039A.057.057,0,0,1,2027.055,790.582Z",
  transform: "translate(-1762.708 -538.443)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_891",
  "data-name": "Path 891",
  d: "M1995.216,874.445c-.1,0-.274-.211-.69-.829l-.029-.043a.056.056,0,0,1,0-.062.054.054,0,0,1,.015-.016.057.057,0,0,1,.02-.008.054.054,0,0,1,.022,0,.058.058,0,0,1,.02.008.054.054,0,0,1,.016.015l.029.043a3.8,3.8,0,0,0,.6.778,2.841,2.841,0,0,0,.615-.847.054.054,0,0,1,.011-.02.058.058,0,0,1,.018-.014.056.056,0,0,1,.045,0,.056.056,0,0,1,.019.013.055.055,0,0,1,.012.019.058.058,0,0,1,0,.022.057.057,0,0,1-.005.022C1995.813,873.83,1995.35,874.445,1995.216,874.445Z",
  transform: "translate(-1730.877 -622.283)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_892",
  "data-name": "Path 892",
  d: "M1412.3,664.45h-2.085a.056.056,0,1,1,0-.112h2.085a.056.056,0,0,1,.04.016.056.056,0,0,1-.04.1Z",
  transform: "translate(-1158.653 -417.507)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_893",
  "data-name": "Path 893",
  d: "M1382.751,715.761H1379.4a.056.056,0,1,1,0-.112h3.354a.056.056,0,1,1,0,.112Z",
  transform: "translate(-1128.472 -467.755)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_894",
  "data-name": "Path 894",
  d: "M1828.571,1031.032h-3.354a.055.055,0,0,1-.04-.017.056.056,0,0,1,.04-.1h3.354a.056.056,0,0,1,.04.016.056.056,0,0,1-.04.1Z",
  transform: "translate(-1565.057 -776.496)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_895",
  "data-name": "Path 895",
  d: "M1786.63,1102.882h-5.394a.058.058,0,0,1-.04-.016.056.056,0,0,1-.016-.04.056.056,0,0,1,.056-.056h5.394a.056.056,0,0,1,.04.1.057.057,0,0,1-.04.016Z",
  transform: "translate(-1521.988 -846.858)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_896",
  "data-name": "Path 896",
  d: "M1786.63,1143.962h-5.394a.056.056,0,0,1-.056-.056.056.056,0,0,1,.056-.056h5.394a.057.057,0,0,1,.04.016.056.056,0,0,1,0,.079.057.057,0,0,1-.04.016Z",
  transform: "translate(-1521.988 -887.087)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_897",
  "data-name": "Path 897",
  d: "M1846.522,1185.022h-2.806a.055.055,0,0,1-.04-.016.056.056,0,0,1,.04-.1h2.806a.055.055,0,0,1,.04.016.056.056,0,0,1,0,.079A.054.054,0,0,1,1846.522,1185.022Z",
  transform: "translate(-1583.174 -927.297)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_898",
  "data-name": "Path 898",
  d: "M2151.222,305.551h-4.286a.055.055,0,0,1-.056-.056.057.057,0,0,1,.016-.04.058.058,0,0,1,.04-.016h4.286a.056.056,0,0,1,.039.016.056.056,0,0,1,0,.079.056.056,0,0,1-.039.016Z",
  transform: "translate(-1880.114 -66.042)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_899",
  "data-name": "Path 899",
  d: "M2198.8,346.633h-2.229a.056.056,0,0,1,0-.112h2.229a.056.056,0,0,1,.056.056.056.056,0,0,1-.056.056Z",
  transform: "translate(-1928.716 -106.273)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_900",
  "data-name": "Path 900",
  d: "M1382.751,690.106H1379.4a.056.056,0,1,1,0-.112h3.354a.056.056,0,1,1,0,.112Z",
  transform: "translate(-1128.472 -442.632)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_901",
  "data-name": "Path 901",
  d: "M1973.212,664.45h-2.086a.056.056,0,0,1,0-.112h2.086a.055.055,0,0,1,.04.016.056.056,0,0,1,0,.079.055.055,0,0,1-.04.016Z",
  transform: "translate(-1707.945 -417.507)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_902",
  "data-name": "Path 902",
  d: "M1958.26,690.106h-2.724a.056.056,0,0,1-.056-.056.055.055,0,0,1,.016-.04.056.056,0,0,1,.04-.016h2.724a.056.056,0,0,1,0,.112Z",
  transform: "translate(-1692.678 -442.632)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_903",
  "data-name": "Path 903",
  d: "M1686.643,464.785h-2.308a.056.056,0,0,1,0-.112h2.308a.056.056,0,1,1,0,.112Z",
  transform: "translate(-1427.095 -221.978)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_904",
  "data-name": "Path 904",
  d: "M1686.643,487.247h-2.308a.056.056,0,0,1,0-.112h2.308a.056.056,0,1,1,0,.112Z",
  transform: "translate(-1427.095 -243.975)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_905",
  "data-name": "Path 905",
  d: "M1758.035,327.02a.055.055,0,0,1-.021,0,.055.055,0,0,1-.018-.012.056.056,0,0,1-.016-.04v-.145a1.48,1.48,0,0,1,.374-1.223c.389-.388,1.592-.36,3.412-.318l.747.016a.056.056,0,0,1,.039.017.056.056,0,0,1-.041.095l-.747-.016c-1.727-.04-2.975-.068-3.33.285a1.375,1.375,0,0,0-.342,1.144v.145a.056.056,0,0,1-.055.056Z",
  transform: "translate(-1499.268 -85.448)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_906",
  "data-name": "Path 906",
  d: "M2513.68,325.174a.054.054,0,0,1-.021-.005.057.057,0,0,1-.018-.013.056.056,0,0,1-.011-.019.055.055,0,0,1,0-.022,1.118,1.118,0,0,0-.236-.878c-.249-.232-.732-.3-1.519-.224a.06.06,0,0,1-.022,0,.057.057,0,0,1-.019-.01.068.068,0,0,1-.014-.017.057.057,0,0,1-.006-.021.055.055,0,0,1,0-.022.053.053,0,0,1,.01-.019.063.063,0,0,1,.017-.014.056.056,0,0,1,.021-.006,2.088,2.088,0,0,1,1.607.255,1.208,1.208,0,0,1,.271.963.055.055,0,0,1-.058.053Z",
  transform: "translate(-2237.484 -84.094)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_907",
  "data-name": "Path 907",
  d: "M2600.606,450.655a.057.057,0,0,1-.04-.016.058.058,0,0,1-.016-.04v-1.1a.058.058,0,0,1,.016-.04.057.057,0,0,1,.04-.016.056.056,0,0,1,.056.056v1.1a.056.056,0,0,1-.056.056Z",
  transform: "translate(-2324.387 -207.067)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_908",
  "data-name": "Path 908",
  d: "M2599.952,557.962a.057.057,0,0,1-.038-.015.056.056,0,0,1-.018-.037,6.81,6.81,0,0,1,.006-.754,6.7,6.7,0,0,0,.007-.741.056.056,0,0,1,.052-.06.058.058,0,0,1,.041.014.055.055,0,0,1,.019.039,6.749,6.749,0,0,1-.005.754,6.642,6.642,0,0,0-.007.741.059.059,0,0,1,0,.022.054.054,0,0,1-.011.019.058.058,0,0,1-.039.019Z",
  transform: "translate(-2323.739 -311.761)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_909",
  "data-name": "Path 909",
  d: "M2601.316,680.032a.057.057,0,0,1-.04-.016.056.056,0,0,1-.016-.04v-1.545a.056.056,0,0,1,.056-.056.055.055,0,0,1,.039.016.056.056,0,0,1,.017.04v1.546a.057.057,0,0,1-.017.038.056.056,0,0,1-.039.016Z",
  transform: "translate(-2325.082 -431.254)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_910",
  "data-name": "Path 910",
  d: "M2601.316,808.411a.056.056,0,0,1-.04-.016.056.056,0,0,1-.016-.04v-1.144a.056.056,0,0,1,.056-.056.055.055,0,0,1,.039.016.056.056,0,0,1,.017.04v1.146a.057.057,0,0,1-.017.038.056.056,0,0,1-.039.016Z",
  transform: "translate(-2325.082 -557.366)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_911",
  "data-name": "Path 911",
  d: "M2464.482,942.143l-.023,2.92-2.481-1.541a2.921,2.921,0,1,0,2.5-1.379Z",
  transform: "translate(-2188.254 -689.558)",
  fill: "#dc5c3f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_912",
  "data-name": "Path 912",
  d: "M2460.482,944.055a3,3,0,0,1-2.553-4.591.084.084,0,0,1,.116-.027l2.354,1.462.022-2.77a.08.08,0,0,1,.007-.032.085.085,0,0,1,.018-.027.087.087,0,0,1,.027-.018.085.085,0,0,1,.032-.006h0a3,3,0,0,1-.024,6.009Zm-2.452-4.429a2.836,2.836,0,1,0,2.559-1.409l-.022,2.835a.084.084,0,0,1-.044.073.084.084,0,0,1-.042.01.083.083,0,0,1-.042-.013Z",
  transform: "translate(-2184.276 -685.546)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_913",
  "data-name": "Path 913",
  d: "M2485.294,942.143h-.024a2.919,2.919,0,0,0-2.48,1.379l2.482,1.541Z",
  transform: "translate(-2209.066 -689.558)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_914",
  "data-name": "Path 914",
  d: "M2481.4,941.084a.088.088,0,0,1-.044-.013l-2.48-1.542a.083.083,0,0,1-.037-.052.086.086,0,0,1,.01-.063,2.989,2.989,0,0,1,2.552-1.42h.024a.086.086,0,0,1,.032.006.087.087,0,0,1,.027.019.085.085,0,0,1,.025.06l-.024,2.92a.085.085,0,0,1-.043.075.089.089,0,0,1-.041.011Zm-2.364-1.652,2.28,1.417.021-2.685a2.822,2.822,0,0,0-2.3,1.268Z",
  transform: "translate(-2205.191 -685.495)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_915",
  "data-name": "Path 915",
  d: "M1903.721,1290.268h0a.057.057,0,0,1-.038-.019.057.057,0,0,1-.014-.041c.007-.1,0-.288-.007-.466s-.014-.367-.007-.477a.055.055,0,0,1,.019-.038.055.055,0,0,1,.041-.014.056.056,0,0,1,.052.059c-.007.1,0,.288.007.466s.014.367.007.477a.056.056,0,0,1-.057.052Z",
  transform: "translate(-1641.92 -1029.44)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_916",
  "data-name": "Path 916",
  d: "M1903.706,1375.583a.056.056,0,0,1-.056-.056v-.731a.055.055,0,0,1,.016-.04.056.056,0,0,1,.1.04v.731a.056.056,0,0,1-.017.04.055.055,0,0,1-.04.016Z",
  transform: "translate(-1641.922 -1113.195)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_917",
  "data-name": "Path 917",
  d: "M1907.412,1449.67a.768.768,0,0,1-.583-.211,1.34,1.34,0,0,1-.248-1.018.056.056,0,0,1,.059-.053.057.057,0,0,1,.039.018.058.058,0,0,1,.015.041,1.241,1.241,0,0,0,.216.934.678.678,0,0,0,.523.177.056.056,0,0,1,.039.016.056.056,0,0,1,.017.039.055.055,0,0,1-.016.04.062.062,0,0,1-.018.013.06.06,0,0,1-.021,0Z",
  transform: "translate(-1644.788 -1185.317)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_918",
  "data-name": "Path 918",
  d: "M1996.585,1502.52l-1.019-.018a.056.056,0,0,1-.056-.056.056.056,0,0,1,.016-.04.056.056,0,0,1,.04-.016h0l1.019.018a.055.055,0,0,1,.04.016.056.056,0,0,1,0,.079A.055.055,0,0,1,1996.585,1502.52Z",
  transform: "translate(-1731.879 -1238.2)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_919",
  "data-name": "Path 919",
  d: "M2100.316,1501.889a.056.056,0,0,1-.056-.056.055.055,0,0,1,.056-.056l1.152-.027a.056.056,0,0,1,.039.017.055.055,0,0,1,0,.079.056.056,0,0,1-.039.017l-1.152.026Z",
  transform: "translate(-1834.459 -1237.574)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_920",
  "data-name": "Path 920",
  d: "M2213.757,1505.025h0l-1.152-.043a.056.056,0,0,1,0-.112l1.151.043a.055.055,0,0,1,.039.017.054.054,0,0,1,.016.04.056.056,0,0,1-.017.04.057.057,0,0,1-.04.016Z",
  transform: "translate(-1944.422 -1240.629)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_921",
  "data-name": "Path 921",
  d: "M2323.776,1507.088a.056.056,0,0,1-.04-.016.056.056,0,0,1,0-.079.056.056,0,0,1,.04-.016l1.284-.026a.055.055,0,0,1,.021,0,.054.054,0,0,1,.019.011.07.07,0,0,1,.012.018.055.055,0,0,1,0,.021.054.054,0,0,1,0,.021.057.057,0,0,1-.012.019.054.054,0,0,1-.018.013.053.053,0,0,1-.021,0l-1.284.027Z",
  transform: "translate(-2053.291 -1242.665)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_922",
  "data-name": "Path 922",
  d: "M2456.663,1507.132h-1.017a.057.057,0,0,1-.04-.017.056.056,0,0,1-.016-.039.057.057,0,0,1,.016-.04.059.059,0,0,1,.04-.016h1.019a.058.058,0,0,1,.04.016.056.056,0,0,1,.016.04.055.055,0,0,1-.016.039.056.056,0,0,1-.04.017Z",
  transform: "translate(-2182.429 -1242.735)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_923",
  "data-name": "Path 923",
  d: "M2562.866,1458.292a.056.056,0,0,1-.039-.016.056.056,0,0,1,0-.079.055.055,0,0,1,.039-.016.708.708,0,0,0,.53-.135,1.242,1.242,0,0,0,.192-.849.056.056,0,0,1,.056-.056.056.056,0,0,1,.056.056,1.309,1.309,0,0,1-.225.928A.818.818,0,0,1,2562.866,1458.292Z",
  transform: "translate(-2287.428 -1193.888)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_924",
  "data-name": "Path 924",
  d: "M2599.461,1309.854a.057.057,0,0,1-.038-.015.056.056,0,0,1-.018-.037c-.02-.268-.009-.642,0-1.037a10.279,10.279,0,0,0,0-1.083.061.061,0,0,1,0-.022.053.053,0,0,1,.011-.019.057.057,0,0,1,.017-.014.051.051,0,0,1,.021-.006.057.057,0,0,1,.041.013.059.059,0,0,1,.02.038c.024.285.011.7,0,1.1-.012.374-.024.763,0,1.025a.057.057,0,0,1-.052.06Z",
  transform: "translate(-2323.255 -1047.466)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_925",
  "data-name": "Path 925",
  d: "M2572.631,1308.788a.051.051,0,0,1-.025-.006.056.056,0,0,1-.025-.075l.57-1.127a.056.056,0,0,1,.021-.022.057.057,0,0,1,.029-.009.056.056,0,0,1,.029.008.053.053,0,0,1,.021.022l.561,1.05a.056.056,0,0,1,.006.021.059.059,0,0,1,0,.022.063.063,0,0,1-.01.019.059.059,0,0,1-.017.014.058.058,0,0,1-.021.006.053.053,0,0,1-.022,0,.057.057,0,0,1-.019-.01.055.055,0,0,1-.014-.017l-.509-.954-.523,1.031a.055.055,0,0,1-.05.03Z",
  transform: "translate(-2296.992 -1047.396)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_926",
  "data-name": "Path 926",
  d: "M2103.637,991.774h0l-.266-.023a.037.037,0,0,1-.034-.041.037.037,0,0,1,.04-.034l.266.023a.037.037,0,0,1,.014,0,.036.036,0,0,1,.011.009.033.033,0,0,1,.007.013.032.032,0,0,1,0,.015.039.039,0,0,1-.012.024A.039.039,0,0,1,2103.637,991.774Z",
  transform: "translate(-1837.469 -738.066)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_927",
  "data-name": "Path 927",
  d: "M1709.224,1250.655h-.376a.038.038,0,0,1-.026-.011.037.037,0,0,1,0-.053.038.038,0,0,1,.026-.011h.376a.037.037,0,1,1,0,.075Z",
  transform: "translate(-1451.117 -991.606)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_928",
  "data-name": "Path 928",
  d: "M1697.858,1239.375a.038.038,0,0,1-.033-.061.039.039,0,0,1,.025-.014,3.058,3.058,0,0,1,.966-.054.029.029,0,0,1,.014,0,.03.03,0,0,1,.011.01.034.034,0,0,1,.007.013.037.037,0,0,1,0,.014.044.044,0,0,1,0,.014.047.047,0,0,1-.009.011.034.034,0,0,1-.013.007h-.015a2.979,2.979,0,0,0-.942.052l-.008,0Z",
  transform: "translate(-1440.351 -980.492)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_929",
  "data-name": "Path 929",
  d: "M2609.047,1198.364a.037.037,0,0,1-.026-.011.037.037,0,0,1,0-.053.037.037,0,0,1,.026-.011,1.418,1.418,0,0,0,.668-.178.033.033,0,0,1,.014,0h.014a.031.031,0,0,1,.013.007.036.036,0,0,1,.01.011.044.044,0,0,1,0,.014.042.042,0,0,1,0,.015.046.046,0,0,1-.007.013.037.037,0,0,1-.011.01,1.483,1.483,0,0,1-.7.187Z",
  transform: "translate(-2332.671 -940.219)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_930",
  "data-name": "Path 930",
  d: "M2721.361,1025.254a.039.039,0,0,1-.023-.007.035.035,0,0,1-.014-.02l-.112-.376a.037.037,0,0,1,0-.016.04.04,0,0,1,0-.015.039.039,0,0,1,.01-.012.04.04,0,0,1,.013-.007.037.037,0,0,1,.016,0,.042.042,0,0,1,.015.005.046.046,0,0,1,.011.01.044.044,0,0,1,.006.014l.112.376a.037.037,0,0,1-.025.046Z",
  transform: "translate(-2442.546 -770.503)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_931",
  "data-name": "Path 931",
  d: "M2694.519,1012.064h0a.056.056,0,0,1-.052-.06,1.241,1.241,0,0,0-.367-.96.056.056,0,0,1,.038-.095.055.055,0,0,1,.04.015,1.354,1.354,0,0,1,.4,1.046.057.057,0,0,1-.017.038A.056.056,0,0,1,2694.519,1012.064Z",
  transform: "translate(-2415.979 -756.939)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_932",
  "data-name": "Path 932",
  d: "M2070.992,356.719h-.005a1.078,1.078,0,0,1-.731-.388.052.052,0,0,1-.011-.019.062.062,0,0,1,0-.022.06.06,0,0,1,.006-.021.057.057,0,0,1,.014-.017.061.061,0,0,1,.02-.01.057.057,0,0,1,.022,0,.053.053,0,0,1,.021.007.051.051,0,0,1,.017.015.969.969,0,0,0,.655.348.056.056,0,0,1,.039.018.061.061,0,0,1,.011.019.072.072,0,0,1,0,.022.063.063,0,0,1-.005.021.066.066,0,0,1-.013.018.057.057,0,0,1-.019.011.054.054,0,0,1-.021,0Z",
  transform: "translate(-1805.062 -115.788)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_933",
  "data-name": "Path 933",
  d: "M1351.412,633.492h-.009a1.857,1.857,0,0,0-.826-.009.036.036,0,0,1-.015,0,.039.039,0,0,1-.014-.005.039.039,0,0,1-.017-.024.041.041,0,0,1,0-.015.04.04,0,0,1,.005-.014.039.039,0,0,1,.01-.011.04.04,0,0,1,.014-.006,1.947,1.947,0,0,1,.859.01.038.038,0,0,1,.025.014.039.039,0,0,1,.008.028.038.038,0,0,1-.014.025.038.038,0,0,1-.028.008Z",
  transform: "translate(-1100.26 -387.175)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_934",
  "data-name": "Path 934",
  d: "M1923.787,752.848h-.009l-.067-.017a.039.039,0,0,1-.013-.006.043.043,0,0,1-.01-.011.045.045,0,0,1,0-.014.041.041,0,0,1,0-.015.037.037,0,0,1,.006-.013.039.039,0,0,1,.011-.01l.014,0a.036.036,0,0,1,.014,0l.067.017a.036.036,0,0,1,.025.014.037.037,0,0,1,.008.028.038.038,0,0,1-.014.025.038.038,0,0,1-.028.008Z",
  transform: "translate(-1661.54 -504.095)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_935",
  "data-name": "Path 935",
  d: "M1913.543,744.7h-.266a.037.037,0,0,1-.026-.011.037.037,0,0,1,0-.053.037.037,0,0,1,.026-.011h.266a.038.038,0,0,1,.026.011.037.037,0,0,1,0,.053A.038.038,0,0,1,1913.543,744.7Z",
  transform: "translate(-1651.313 -496.129)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_936",
  "data-name": "Path 936",
  d: "M1158.578,2744.29H1156a.156.156,0,0,0-.156.156h0a.156.156,0,0,0,.156.156h2.582a.156.156,0,0,0,.156-.156h0A.156.156,0,0,0,1158.578,2744.29Z",
  transform: "translate(-909.601 -2454.377)",
  fill: "#dc5c3f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_937",
  "data-name": "Path 937",
  d: "M1156.335,2742h-2.582a.213.213,0,0,1,0-.425h2.582a.213.213,0,0,1,.2.212.213.213,0,0,1-.2.212Zm-2.582-.312a.1.1,0,0,0-.067.032.1.1,0,0,0-.027.068.1.1,0,0,0,.094.1h2.582a.1.1,0,0,0,.094-.1.1.1,0,0,0-.027-.068.1.1,0,0,0-.067-.032Z",
  transform: "translate(-907.358 -2451.723)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_938",
  "data-name": "Path 938",
  d: "M285.7,1186.178a.055.055,0,0,1-.035-.013.055.055,0,0,1-.019-.032.62.62,0,0,1,.216-.587.061.061,0,0,1,.019-.01.057.057,0,0,1,.022,0,.055.055,0,0,1,.021.006.057.057,0,0,1,.017.014.056.056,0,0,1,.01.019.056.056,0,0,1,0,.043.055.055,0,0,1-.014.017.513.513,0,0,0-.176.479.055.055,0,0,1,0,.022.055.055,0,0,1-.009.02.051.051,0,0,1-.016.015.05.05,0,0,1-.02.008Z",
  transform: "translate(-57.419 -927.907)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_939",
  "data-name": "Path 939",
  d: "M1422.344,1085.6h-.01a2.661,2.661,0,0,0-1.448-.013.037.037,0,0,1-.028,0,.038.038,0,0,1-.017-.022.037.037,0,0,1,0-.028.038.038,0,0,1,.022-.018,2.738,2.738,0,0,1,1.489.013.037.037,0,0,1,.032.043.038.038,0,0,1-.015.025.038.038,0,0,1-.028.007Z",
  transform: "translate(-1169.112 -829.861)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_940",
  "data-name": "Path 940",
  d: "M1752.026,2399.228a.077.077,0,0,1-.031-.006,139.587,139.587,0,0,1-12.953-6.39.083.083,0,0,1-.031-.031.081.081,0,0,1-.011-.043v-.623a.081.081,0,0,1,.009-.038.08.08,0,0,1,.025-.03.089.089,0,0,1,.036-.015.082.082,0,0,1,.039,0l14.271,4.484a.083.083,0,0,1,.056.058.082.082,0,0,1,0,.042.085.085,0,0,1-.02.037,8.139,8.139,0,0,0-1.31,2.493.091.091,0,0,1-.017.03.083.083,0,0,1-.027.02.08.08,0,0,1-.037.009Zm-12.858-6.519a138.773,138.773,0,0,0,12.806,6.324,8.178,8.178,0,0,1,1.233-2.372l-14.038-4.41Z",
  transform: "translate(-1480.682 -2109.433)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_941",
  "data-name": "Path 941",
  d: "M1753.355,1932.18a.082.082,0,0,1-.025,0l-14.271-4.484a.084.084,0,0,1-.042-.031.086.086,0,0,1-.016-.05v-9.8a.085.085,0,0,1,.019-.053.087.087,0,0,1,.048-.029,2.986,2.986,0,0,1,1.176.072,5.124,5.124,0,0,1,2.579,1.615c1.837,2,11.852,11.262,11.953,11.355a.085.085,0,0,1,.024.037.086.086,0,0,1,0,.044.083.083,0,0,1-.021.039.082.082,0,0,1-.038.023s-.46.149-1.319,1.233a.085.085,0,0,1-.03.024A.081.081,0,0,1,1753.355,1932.18Zm-14.187-4.63,14.157,4.447a4.609,4.609,0,0,1,1.243-1.188c-1.019-.941-10.124-9.376-11.872-11.278a4.278,4.278,0,0,0-3.528-1.644Z",
  transform: "translate(-1480.682 -1644.91)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_942",
  "data-name": "Path 942",
  d: "M800.094,1298.884c.506-.172,1.386-.807,2.26-1.213.3-2.145,3.126-5.913,2.462-9.25-.023-.115-.146-.21-.24-.281a.672.672,0,0,0-.242.347c-.472,4.13-3.974,7.65-4.215,7.861A4.7,4.7,0,0,0,800.094,1298.884Z",
  transform: "translate(-561.067 -1028.388)",
  fill: "#34728c"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_943",
  "data-name": "Path 943",
  d: "M797.491,1296.3a.056.056,0,0,1-.051-.034,4.671,4.671,0,0,1,.037-2.6c.037-.032,3.709-3.565,4.2-7.826a.716.716,0,0,1,.26-.381.057.057,0,0,1,.072,0,.613.613,0,0,1,.262.315c.432,2.167-.618,4.557-1.461,6.476a12.066,12.066,0,0,0-1,2.792.057.057,0,0,1-.01.026.056.056,0,0,1-.021.017c-.418.194-.843.445-1.219.665a6.817,6.817,0,0,1-1.046.55.052.052,0,0,1-.017,0Zm4.484-10.725a.559.559,0,0,0-.19.28c-.49,4.3-4.2,7.864-4.232,7.9a4.875,4.875,0,0,0-.03,2.422,7.515,7.515,0,0,0,.976-.523c.369-.218.787-.463,1.2-.658a12.388,12.388,0,0,1,1-2.792c.837-1.906,1.879-4.275,1.454-6.409a.457.457,0,0,0-.182-.217Z",
  transform: "translate(-558.464 -1025.749)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_944",
  "data-name": "Path 944",
  d: "M833.371,1740.256h-.009l-.531-.133a.036.036,0,0,1-.014-.005.037.037,0,0,1-.011-.011.041.041,0,0,1-.006-.015.036.036,0,0,1,0-.015.037.037,0,0,1,.007-.014.04.04,0,0,1,.012-.01.036.036,0,0,1,.015,0,.041.041,0,0,1,.015,0l.531.133a.039.039,0,0,1,.025.014.038.038,0,0,1,.008.028.037.037,0,0,1-.014.025.038.038,0,0,1-.028.008Z",
  transform: "translate(-593.251 -1470.936)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_945",
  "data-name": "Path 945",
  d: "M899.365,1629.129h0l-.6-.068a.042.042,0,0,1-.014,0,.035.035,0,0,1-.011-.01.038.038,0,0,1-.008-.027.039.039,0,0,1,0-.014.043.043,0,0,1,.01-.011.037.037,0,0,1,.013-.006.031.031,0,0,1,.015,0l.6.068a.037.037,0,0,1,.023.065.036.036,0,0,1-.027.009Z",
  transform: "translate(-657.816 -1362.175)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_946",
  "data-name": "Path 946",
  d: "M903.65,1642.285h-.1a.037.037,0,0,1-.026-.011.038.038,0,0,1-.011-.027.037.037,0,0,1,.011-.026.037.037,0,0,1,.026-.011h.1a.037.037,0,0,1,.037.037.038.038,0,0,1-.011.027A.037.037,0,0,1,903.65,1642.285Z",
  transform: "translate(-662.501 -1375.124)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_947",
  "data-name": "Path 947",
  d: "M979.095,1491.545h-.166a.037.037,0,0,1-.026-.011.038.038,0,0,1-.011-.026.037.037,0,0,1,.011-.026.036.036,0,0,1,.026-.011h.166a.037.037,0,0,1,.026.011.037.037,0,0,1,.011.026.038.038,0,0,1-.011.026A.037.037,0,0,1,979.095,1491.545Z",
  transform: "translate(-736.317 -1227.507)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_948",
  "data-name": "Path 948",
  d: "M973.838,1249.43l-1.027.574s.6.824,1.027.675C974.21,1250.55,973.838,1249.43,973.838,1249.43Z",
  transform: "translate(-730.363 -990.48)",
  fill: "#34728c"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_949",
  "data-name": "Path 949",
  d: "M971.086,1248.041c-.44,0-.941-.684-.964-.716a.056.056,0,0,1-.01-.021.059.059,0,0,1,0-.024.057.057,0,0,1,.027-.037l1.027-.574a.056.056,0,0,1,.023-.007.058.058,0,0,1,.024,0,.055.055,0,0,1,.021.013.059.059,0,0,1,.013.021c.04.12.377,1.177-.035,1.32A.392.392,0,0,1,971.086,1248.041Zm-.835-.731c.187.243.627.708.925.6.221-.075.114-.7-.014-1.114Z",
  transform: "translate(-727.719 -987.77)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_950",
  "data-name": "Path 950",
  d: "M904.26,1198.311a1.494,1.494,0,0,1,.108.661c.43.212.934.413,1.14.318.305-.141.138-1.127.138-1.127s.34-.1,1.006.626c.719.785.743,1.225.625,1.378-.133.172-1.507-.631-1.507-.631s-.4,1.9-.685,1.94-1.33-1.387-1.373-1.78c.032-.446.083-.856.083-.856A1.626,1.626,0,0,1,904.26,1198.311Z",
  transform: "translate(-662.695 -940.27)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_951",
  "data-name": "Path 951",
  d: "M902.415,1198.978a.4.4,0,0,1-.226-.108,4.531,4.531,0,0,1-1.191-1.722s0-.007,0-.01c.032-.443.083-.855.084-.86a.074.074,0,0,1,0-.015,1.637,1.637,0,0,1,.486-.551.061.061,0,0,1,.023-.01.056.056,0,0,1,.025,0,.053.053,0,0,1,.022.012.052.052,0,0,1,.015.02,1.548,1.548,0,0,1,.114.651c.724.352.973.34,1.058.3.194-.089.168-.7.106-1.067a.055.055,0,0,1,.039-.063c.015-.005.382-.1,1.064.642.7.764.785,1.25.628,1.45-.058.075-.2.1-.873-.235-.264-.132-.523-.276-.64-.344-.034.154-.117.519-.219.884-.249.882-.4,1.009-.5,1.024Zm-1.3-1.838a4.638,4.638,0,0,0,1.148,1.642c.107.083.149.085.162.083s.156-.063.4-.942c.133-.473.233-.947.234-.952a.058.058,0,0,1,.011-.024.054.054,0,0,1,.021-.016.055.055,0,0,1,.051,0,4.387,4.387,0,0,0,1.437.643c.1-.124.074-.541-.624-1.3-.486-.53-.788-.605-.9-.612.035.236.119.988-.179,1.126-.187.087-.576-.017-1.188-.318a.057.057,0,0,1-.024-.023.055.055,0,0,1-.007-.032,1.438,1.438,0,0,0-.075-.566,1.463,1.463,0,0,0-.386.453C901.185,1196.36,901.14,1196.737,901.11,1197.14Z",
  transform: "translate(-660.038 -937.716)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_952",
  "data-name": "Path 952",
  d: "M918.144,1228.626a.054.054,0,0,1-.023-.005l-.354-.155a.056.056,0,1,1,.045-.1l.354.156a.056.056,0,0,1,.032.063.057.057,0,0,1-.019.032.056.056,0,0,1-.035.013Z",
  transform: "translate(-676.427 -969.845)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_953",
  "data-name": "Path 953",
  d: "M2425.077,363.694a.036.036,0,0,1-.027-.01.035.035,0,0,1-.012-.026.037.037,0,0,1,.01-.027.038.038,0,0,1,.026-.012l.265-.019a.037.037,0,0,1,.027.009.036.036,0,0,1,.013.025.039.039,0,0,1-.009.027.038.038,0,0,1-.026.013l-.266.02Z",
  transform: "translate(-2152.511 -122.998)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_954",
  "data-name": "Path 954",
  d: "M2410.711,356.97h-.554a.037.037,0,0,1,0-.075h.554a.037.037,0,0,1,.026.011.037.037,0,0,1,0,.053A.037.037,0,0,1,2410.711,356.97Z",
  transform: "translate(-2137.901 -116.432)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_955",
  "data-name": "Path 955",
  d: "M2138.8,262.882h-.2a.037.037,0,0,1,0-.075h.2a.037.037,0,0,1,.026.011.037.037,0,0,1,0,.053A.037.037,0,0,1,2138.8,262.882Z",
  transform: "translate(-1871.966 -24.293)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_956",
  "data-name": "Path 956",
  d: "M2090.467,629.395a.036.036,0,0,1-.026-.011.037.037,0,0,1,0-.053.036.036,0,0,1,.026-.011l.532-.018a.037.037,0,0,1,0,.075l-.531.018Z",
  transform: "translate(-1824.833 -383.197)",
  fill: "#13484f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_957",
  "data-name": "Path 957",
  d: "M2116.2,639.21h-.112a.037.037,0,0,1,0-.075h.112a.037.037,0,0,1,0,.075Z",
  transform: "translate(-1849.922 -392.826)",
  fill: "#13484f"
}))));
export default __webpack_public_path__ + "static/media/MoverIllustrationFree.aacc6fbb.svg";
export { SvgComponent as ReactComponent };